/* eslint-disable arrow-body-style */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-danger */
/* eslint-disable react/button-has-type */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-lonely-if */
/* eslint-disable radix */
import React, { useState, useEffect, useRef, useCallback, useLayoutEffect } from 'react';
import { Box, Chip, Card, CardContent, Typography, Divider, Button, Tooltip, Backdrop, CircularProgress, Grid, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Paper, styled, TableContainer, Table, Accordion, AccordionSummary, AccordionDetails, TableHead, TableRow, TableCell, TableBody, Tab, Tabs } from "@mui/material";
import DoneIcon from '@mui/icons-material/Done';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { useNavigate, useLocation } from 'react-router-dom';
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import { makeStyles } from '@mui/styles';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import CoffeeIcon from "@mui/icons-material/Coffee";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import moment from 'moment';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import InsightsIcon from "@mui/icons-material/Insights";
import PaymentIcon from '@mui/icons-material/Payment';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Popover from '@mui/material/Popover';
import PsychologyIcon from "@mui/icons-material/Psychology";
import BookmarkIcon from '@mui/icons-material/Bookmark';
import { CheckCircleIcon, GlobeAltIcon, VideoCameraIcon, UsersIcon } from "@heroicons/react/24/outline";
import { useDispatch, useSelector } from 'react-redux';
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import LaunchIcon from '@mui/icons-material/Launch';
import Draggable from 'react-draggable';
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import CloseIcon from '@mui/icons-material/Close';
import Calculator from '../../../components/Calculator';
import adminServices from '../../../services/adminServices';
import LottieLoading from '../../../components/LottieLoading';
import IconCalculator from '../../../assets/Images/calculator.png';
import TestComplete from '../../../assets/Images/TestComplete.png';
import { FromGeneralAssessmentView } from '../../../store/reducer'
import chapterCover from '../../../assets/Images/ChapterTestSAT.png';
import analysisNotAttempted from '../../../assets/Images/attemptTheAttemptImage.png'
import AssessmentSkeleton from "../../../components/loaders/AssessmentSkeleton";


function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

dayjs.extend(customParseFormat);

function PaperComponent(props) {

    return (
        <Draggable handle=".drag-handle" bounds="body" cancel={'[class*="MuiDialogContent-root"]'}  >
            <Paper {...props} />
        </Draggable>
    );
}

export default function ChapterLevelSimulation() {
    const location = useLocation();
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const { userInfo } = useSelector((state) => state);
    const allassessmentdetails = useSelector((state) => state);
    const [questions, setQuestions] = useState([])
    const [instructions, setInstructions] = useState(false)
    const [Chapterdetails, setChapterDetails] = useState('')
    const [analysisPayload, setAnalysisPayload] = useState(null);
    const allcourseDetails = useSelector((state) => state);

    const [tabIndex, setTabIndex] = useState(0);
    const classes = useStyles();
    const [value, setValue] = useState(0);
    const [testView, setTestView] = useState(false)
    const [isPaused, setIsPaused] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [openDrop, setOpendrop] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [overlayZIndex, setOverlayZIndex] = useState('none');
    const [markedForReview, setMarkedForReview] = useState({});
    const [parsedOptions, setParsedOptions] = useState([]);
    const [startTime, setStartTime] = useState('');
    const [questionTimes, setQuestionTimes] = useState([]);
    const [questionListAnchorEl, setQuestionListAnchorEl] = useState(null);
    const [time, setTime] = useState(0);
    const [gridLeft, setGridLeft] = useState(6);
    const [gridRight, setGridRight] = useState(6);
    const currentQuestion = questions && questions[currentIndex];
    const [calculatorOpen, setCalculatorOpen] = useState(false);
    const [showModuleComplete, setShowModuleComplete] = useState(false);
    const [selectedAnswers, setSelectedAnswers] = useState({});
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [showCongratulationsModal, setShowCongratulationsModal] = useState(false);
    const userRole = useSelector((state) => state.userInfo && state.userInfo.role);
    const open = Boolean(anchorEl);
    const [assessmentTabIndex, setAssessmentTabIndex] = useState(0);
    const [analysisTestScore, setAnalysisTestScore] = useState([]);
    const [allQuestions, setAllQuestions] = useState([]);
    const [activeTabs, setActiveTabs] = useState(location.state?.data?.assessment_type === 'Maths Chapter Test' ? "m1" : "rw1");
    const [selectedAttemptIndex, setSelectedAttemptIndex] = useState(0);
    const isAssessmentPaid = Chapterdetails?.is_payment === true && Chapterdetails?.ispaid === true;
    const isAssessmentUnpaid = Chapterdetails?.is_payment === true && Chapterdetails?.ispaid === false;

    const getAccurateElapsed = () => {
        const now = Date.now();
        let elapsed = 0;

        if (backgroundStartRef.current) {
            elapsed += backgroundStartRef.current - lastUpdateRef.current;
            elapsed += now - backgroundStartRef.current;
            backgroundStartRef.current = null;
        } else {
            elapsed = now - lastUpdateRef.current;
        }

        lastUpdateRef.current = now;
        return Math.floor(elapsed / 1000);
    };

    const lastUpdateRef = useRef(Date.now());
    const backgroundStartRef = useRef(null);
    const timerRef = useRef(null);

    const priceData = React.useMemo(() => {
        const filteredList = Chapterdetails?.stripe_pricing_list?.filter(data =>
            allcourseDetails?.currency === "USD"
                ? data?.related_currency_type_lk === 2
                : data?.related_currency_type_lk === 1
        );

        let numericPrice = null;
        let displayPrice = "N/A";

        if (filteredList && filteredList.length > 0) {
            numericPrice = Number(filteredList[0].value);

            if (Number.isFinite(numericPrice)) {
                if (allcourseDetails?.currency === "USD") {
                    displayPrice = `$${numericPrice}`;
                } else if (allcourseDetails?.currency === "INR") {
                    displayPrice = `₹${numericPrice}`;
                }
            }
        }

        return { numericPrice, displayPrice };
    }, [Chapterdetails?.stripe_pricing_list, allcourseDetails?.currency]);

    const computedViewPrice = priceData.displayPrice;
    const originalPrice = Number.isFinite(priceData.numericPrice) ? priceData.numericPrice * 2 : null;

    const updateTimer = () => {
        const elapsedSeconds = getAccurateElapsed();
        setTime(prev => {
            const newTime = prev - elapsedSeconds;

            if (newTime <= 0) {
                if (testView) {
                    handlePostUserResult();

                }
                return 0;
            }
            return newTime;
        });
    };
    const startTimer = () => {
        if (time > 0) {
            timerRef.current = setInterval(updateTimer, 1000);
        }
    };

    useEffect(() => {
        const assessmentResult = Chapterdetails?.assessment_results?.[0];
        const userResultsArray = assessmentResult?.user_result || [];
        const selectedAttemptResult = userResultsArray[selectedAttemptIndex] || [];
        const isSelectedAttemptCompleted = selectedAttemptResult.length > 0;

        if (
            assessmentTabIndex === 2 &&
            Chapterdetails?.id &&
            selectedAttemptIndex !== undefined &&
            isSelectedAttemptCompleted
        ) {
            fetchAnalytics(selectedAttemptIndex);
        }
    }, [assessmentTabIndex, selectedAttemptIndex, Chapterdetails?.id, Chapterdetails?.assessment_results]);

    const timesNormalized = analysisTestScore?.Questions?.map(q =>
        q.timeTaken > 1000000
            ? q.timeTaken / 1000000000
            : q.timeTaken
    );
    const totalTime = timesNormalized?.reduce((acc, time) => acc + time, 0);
    const avgTime = totalTime / analysisTestScore?.Questions?.length;

    const useMobileLandscape = () => {
        const [isMobileLandscape, setIsMobileLandscape] = useState(
            window.innerWidth > 600 && window.innerHeight <= 455
        );

        useEffect(() => {
            const handleResize = () => {
                setIsMobileLandscape(
                    window.innerWidth > 600 && window.innerHeight <= 455
                );
            };
            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }, []);
        return isMobileLandscape;
    }

    const mobileLandscape = useMobileLandscape();

    useEffect(() => {
        getChapterDetails()
    }, [location.state?.chapterid])


    const getChapterDetails = async () => {
        setIsLoading(true);
        const chapterdetails = await adminServices.IndividualChapterDetails(location.state?.chapterid, userInfo?.id)
        setChapterDetails(chapterdetails?.data)
        const attemptCount = chapterdetails?.data?.assessment_results?.[0]?.user_result?.length || 0;
        const latestAttemptIndex = attemptCount > 0 ? attemptCount - 1 : 0;
        setSelectedAttemptIndex(latestAttemptIndex);
        setIsLoading(false);
    }



    useEffect(() => {
        lastUpdateRef.current = Date.now();
        startTimer();

        return () => {
            clearInterval(timerRef.current);
        };
    }, [isPaused, time]);

    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.hidden) {
                clearInterval(timerRef.current);
                backgroundStartRef.current = Date.now();
            } else {
                updateTimer();
                startTimer();
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);
        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [isPaused, testView]);

    const fetchAnalytics = async (attemptIndex) => {
        const chapterId = Chapterdetails?.id;
        const userId = userInfo?.id;

        if (!chapterId || userId === undefined || attemptIndex === undefined) {
            console.log('Missing required parameters:', { chapterId, userId, attemptIndex });
            return;
        }
        setIsLoading(true);
        try {
            const result = await adminServices.getChapterLevelAnalysis(chapterId, userId, attemptIndex, 'Chapter');

            if (result?.ok) {
                setAnalysisTestScore(result.data);
                setAllQuestions(result.data?.Questions || []);
            }
        } catch (error) {
            console.error('Error fetching analytics:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleViewAnalysis = async (assessment, index) => {
        setSelectedAttemptIndex(index);

        setAssessmentTabIndex(2);


    };



    useEffect(() => {
        if (instructions === true && testView === true) {
            dispatch(FromGeneralAssessmentView(true));
        } else {
            dispatch(FromGeneralAssessmentView(false));
        }
    }, [instructions, testView, dispatch]);


    const handleCalculatorOpen = () => setCalculatorOpen(true);
    const handleCalculatorClose = () => setCalculatorOpen(false);
    const formatTimeTimer = (seconds) => {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    };

    const handleOpenQuestionList = (event) => {
        setQuestionListAnchorEl(event.currentTarget);
        setOverlayZIndex('block');
    };

    const handleCloseQuestionList = () => {
        setQuestionListAnchorEl(null);
        setOverlayZIndex('none');
    };

    const handleChange = (event, newValue) => {
        setValue(newValue);
        if (newValue === 2) {
            // alert("55", assessmentDetails?.length, "1155")
        }
    };

    const handleAssessmentTabChange = (newValue) => {
        setAssessmentTabIndex(newValue);
    };

    const AssessmentTabs = [
        <Tab key="Overview" label="Overview" />,
        <Tab key="Attempts" label="Attempts" />,
        <Tab key="Analytics" label="Analytics" />
    ];



    const handleClose = () => {
        setAnchorEl(null);
        setOverlayZIndex('none');
    };
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        setOverlayZIndex('block');
    };

    const handleNavigation = () => {
        const comingfrom = "Chapter"
        if (userInfo?.role === 'AUTH_USER') {
            navigate('/app/course', { state: comingfrom });
        }
        else {
            navigate('/auth/subscribe', { state: comingfrom });
        }
    }



    const handleNavigationtoChapter = () => {

        if (userInfo?.role === 'AUTH_USER') {
            navigate('/app/ChapterOverView', {
                state: {
                    type: Chapterdetails?.assessment_type === "Maths Chapter Test" ? 'Maths' : 'English'
                }
            });
        } else {
            navigate('/auth/ChapterOverView', {
                state: Chapterdetails?.assessment_type === "Maths Chapter Test" ? 'Maths' : 'English'
            });
        }
    }

    const handleGridLeft = () => {

        if (gridLeft === 7 && gridRight === 5) {
            setGridLeft(6);
            setGridRight(6)
        }
        else {
            setGridLeft(7);
            setGridRight(5)
        }
    }
    const handleGridRight = () => {
        if (gridLeft === 5 && gridRight === 7) {
            setGridLeft(6);
            setGridRight(6)
        }
        else {
            setGridLeft(5);
            setGridRight(7)
        }

    }

    const handleSubmit = async () => {
        setOpenConfirmDialog(true);

    };

    const GraphIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-5">
            <path strokeLinecap="round" strokeLinejoin="round" d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875v-6.75ZM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625ZM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.125Z" />
        </svg>
    );

    const handleStartTest = (chapter) => {
        const type = chapter?.data?.chapter_code?.includes("Eng") ? "English" : "Maths"
        getStartSATChapterAssessment(chapter?.id, type)
        setInstructions(true)
    }

    const handleQuestionSelect = (index) => {
        const endTime = Date.now();
        const timeSpent = (endTime - startTime) / 1000;

        setQuestionTimes((prev) => ({
            ...prev,
            [currentIndex]: (prev[currentIndex] || 0) + timeSpent,
        }));

        setStartTime(Date.now());
        setCurrentIndex(index);
        handleCloseQuestionList();
    };


    const handleBookmarkTrue = (index) => {
        setMarkedForReview((prevState) => ({
            ...prevState,
            [index]: true,
        }));
    };

    const handleBookmarkFalse = (index) => {
        setMarkedForReview((prevState) => ({
            ...prevState,
            [index]: false,
        }));
    };

    const onBack = () => {
        setTestView(false);
        setInstructions(false);
        setCurrentIndex(0);
        setSelectedAnswers([]);
        setQuestionTimes([]);
        setMarkedForReview({});
        // setCorrectAnswer([]);
        setTime(0);
        setIsPaused(false);
        setShowModuleComplete(false);
        setCalculatorOpen(false);
    };


    const onStartTest = () => {
        setTime(1800)
        setTestView(true)
    }

    const getStartSATChapterAssessment = async (chapterid, type) => {
        setIsLoading(true);
        try {
            const result = await adminServices.getStartSATChapterAssessment(chapterid, type);
            if (result.ok) {
                setQuestions(result.data);
            }
        } catch (error) {
            console.error('Error starting assessment:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const getCurrentTime = () => {
        const now = new Date();
        const hours = now.getHours().toString().padStart(2, '0');
        const minutes = now.getMinutes().toString().padStart(2, '0');
        const seconds = now.getSeconds().toString().padStart(2, '0');

        return `${hours}:${minutes}:${seconds}`;
    };

    useEffect(() => {
        if (currentQuestion && currentQuestion.options) {
            try {
                const parsed = typeof currentQuestion.options === 'string'
                    ? JSON.parse(currentQuestion.options)
                    : currentQuestion.options;

                setParsedOptions(parsed.mcqOptions);
            } catch (error) {
                console.error("Failed to parse options:", error);
                setParsedOptions([]);
            }
        }
    }, [currentQuestion]);

    const handleNext = () => {
        const endTime = Date.now();
        const timeSpent = (endTime - startTime) / 1000;
        const currentQuestion = questions[currentIndex];
        setStartTime(Date.now());
        setQuestionTimes((prev) => ({
            ...prev,
            [currentIndex]: (prev[currentIndex] || 0) + timeSpent,
        }));


        if (currentIndex < questions.length - 1) {
            setCurrentIndex(currentIndex + 1);
        }
    };


    const handleBack = () => {
        if (currentIndex > 0) {
            const endTime = Date.now();
            const timeSpent = (endTime - startTime) / 1000;

            setQuestionTimes((prev) => ({
                ...prev,
                [currentIndex]: (prev[currentIndex] || 0) + timeSpent,
            }));

            setStartTime(Date.now());
            setCurrentIndex(currentIndex - 1);
        }
    };




    const handleOptionSelect = (option, index) => {
        let parsedData;

        try {
            parsedData = typeof currentQuestion?.options === 'string'
                ? JSON.parse(currentQuestion.options)
                : currentQuestion.options;
            setSelectedAnswers((prev) => ({
                ...prev,
                [currentIndex]: option,
            }));
        } catch (error) {

            setSelectedAnswers((prev) => ({
                ...prev,
                [currentIndex]: option,
            }));
        }
    };

    const handleClearResponse = () => {
        setSelectedAnswers((prev) => {
            const newAnswers = { ...prev };
            delete newAnswers[currentIndex];
            return newAnswers;
        });

    };

    const Clock = () => {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6" >
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
            </svg>
        );
    };

    const Document = () => {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6" >
                <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
            </svg>
        );
    };

    const Graph = () => {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6" >
                <path strokeLinecap="round" strokeLinejoin="round" d="M7.5 14.25v2.25m3-4.5v4.5m3-6.75v6.75m3-9v9M6 20.25h12A2.25 2.25 0 0 0 20.25 18V6A2.25 2.25 0 0 0 18 3.75H6A2.25 2.25 0 0 0 3.75 6v12A2.25 2.25 0 0 0 6 20.25Z" />
            </svg>
        );
    };

    const Bolt = () => {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6" >
                <path strokeLinecap="round" strokeLinejoin="round" d="m3.75 13.5 10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75Z" />
            </svg>
        );
    };

    const WarningIcon = ({ size = 20 }) => {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#D946EF" width={size} height={size} >
                <path fillRule="evenodd" d="M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" clipRule="evenodd" />
            </svg>
        );
    };

    const BellIcon = ({ size = 20, className = "" }) => (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width={size} height={size} className={className}>
            <path d="M5.85 3.5a.75.75 0 0 0-1.117-1 9.719 9.719 0 0 0-2.348 4.876.75.75 0 0 0 1.479.248A8.219 8.219 0 0 1 5.85 3.5ZM19.267 2.5a.75.75 0 1 0-1.118 1 8.22 8.22 0 0 1 1.987 4.124.75.75 0 0 0 1.48-.248A9.72 9.72 0 0 0 19.266 2.5Z" />
            <path fillRule="evenodd" clipRule="evenodd" d="M12 2.25A6.75 6.75 0 0 0 5.25 9v.75a8.217 8.217 0 0 1-2.119 5.52.75.75 0 0 0 .298 1.206c1.544.57 3.16.99 4.831 1.243a3.75 3.75 0 1 0 7.48 0 24.583 24.583 0 0 0 4.83-1.244.75.75 0 0 0 .298-1.205 8.217 8.217 0 0 1-2.118-5.52V9A6.75 6.75 0 0 0 12 2.25ZM9.75 18c0-.034 0-.067.002-.1a25.05 25.05 0 0 0 4.496 0l.002.1a2.25 2.25 0 1 1-4.5 0Z" />
        </svg>
    );

    const StatCard = ({ icon: Icon, value, label }) => {
        return (
            <div className="bg-white border rounded-lg px-4 py-3 w-full">
                <div className="text-gray-700 mb-2"><Icon /></div>
                <div className="text-xl font-semibold text-gray-900 leading-tight mb-2">{value}</div>
                <div className="text-xs text-gray-500">{label}</div>
            </div>
        );
    };


const StatItem = ({ label, value, colorDot, subText }) => (
  <Box
    sx={{
      py: 1,
      display: "flex",
      flexDirection: "column",
      height: "100%",
    }}
  >
    {/* Label */}
    <Box display="flex" alignItems="center" gap={1} mb={1}>
      {colorDot && (
        <Box
          sx={{
            width: 8,
            height: 8,
            borderRadius: "50%",
            bgcolor: colorDot,
          }}
        />
      )}
      <Typography fontSize={14} fontWeight={600} color="text.secondary">
        {label}
      </Typography>
    </Box>

    {/* Value */}
    <Typography
      fontSize={{ xs: 18, md: 34 }}
      fontWeight={800}
      color="#102A63"
      lineHeight={1.1}
      mt={0.5}   
    >
      {value}
    </Typography>

    {/* Sub text */}
    {subText && (
      <Typography
        fontSize={14}
        color="text.secondary"
        mt={0.5}
      >
        {subText}
      </Typography>
    )}
  </Box>
);



const ScoreCard = () => {
  if (!analysisTestScore) return null;

  return (
    <Card sx={{ p: { xs: 2, sm: 3 } }}>
      <Typography fontSize={18} fontWeight={700} mb={3}>
        Performance Overview
      </Typography>

      {/* Stats Grid */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: '1fr',
            sm: 'repeat(2, 1fr)',
            md: 'repeat(5, 1fr)',
          },
          gap: { xs: 2, md: 0 },
          p: 2,
        }}
      >
        {[
          {
            label: 'Correct Answers',
            value: analysisTestScore.totalCorrectAnswers,
            colorDot: '#4CAF50',
          },
          {
            label: 'Incorrect Answers',
            value: analysisTestScore.totalIncorrectAnswers,
            colorDot: '#FF0000',
          },
          {
            label: 'Questions Attempted',
            value: `${analysisTestScore?.attemptedQuestions || 0}/${analysisTestScore?.totalQuestions || 0}`,
            colorDot: '#B3B3B3',
          },
          {
            label: 'Overall Accuracy',
            value: `${analysisTestScore.overallAccuracy}%`,
          },
          {
            label: 'Time Spent Per Question',
            value: `${avgTime.toFixed(0)}s`,
          },
        ].map((item, index) => (
          <Box
            key={item.label}
            sx={{
              borderRight: {
                xs: 'none',
                md: index !== 4 ? '1px solid #E5EAF2' : 'none',
              },
              pr: { md: 3 }, 
              mr: { md: 2 }, 
            }}
          >
            <StatItem {...item} />
          </Box>
        ))}
      </Box>
      <Box mt={3} pt={2} borderTop="1px solid #E5EAF2">
        <Typography fontWeight={600} mb={0.5}>
          Improvement Tips:
        </Typography>
        <Typography color="text.secondary">
          Steady effort makes the difference. Continue completing practice tests to move toward your ideal SAT score.
        </Typography>
      </Box>
    </Card>
  );
};



    const QuestionWiseAnalysis = () => {

        const [expanded, setExpanded] = useState(null);

        const handleAccordionChange = (panel) => (event, isExpanded) => {
            setExpanded(isExpanded ? panel : null);
        };

        useLayoutEffect(() => {
            const savedScrollPosition = sessionStorage.getItem('scrollPosition');
            if (savedScrollPosition) {
                window.scrollTo(0, parseInt(savedScrollPosition, 10));
            }
        }, [activeTabs]);


        useEffect(() => {
            const handleScroll = () => {
                sessionStorage.setItem('scrollPosition', window.scrollY);
            };
            window.addEventListener('scroll', handleScroll);
            return () => window.removeEventListener('scroll', handleScroll);
        }, []);

        const isPassageVisible = (location.state?.data?.type === "Chapter" && location.state?.data?.assessment_type === 'English Chapter Test') // English

        return (
            <>
                <Typography variant="h5" sx={{ fontWeight: 600, mb: 2, fontSize: { xs: '14px', sm: '26px', md: '26px' } }}>
                    Question-wise Analysis
                </Typography>

                <Box
                    sx={{
                        background: '#eaf2fe',
                        textAlign: 'center',
                        color: '#225AD6',
                        fontWeight: 600,
                        fontSize: { xs: 10, sm: 13, md: 14 },
                        borderBottom: '2px solid #225AD6',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: { xs: '8px 10px', sm: '10px 12px', md: '10px 12px' },
                        width: '100%',
                        height: '50px',
                        mb: 3,
                    }}
                >
                    {Chapterdetails?.chapter_description} Test
                </Box>

                <Box sx={{ mt: 4 }}>

                    {allQuestions && allQuestions?.length > 0 && allQuestions.map((question, index) => (
                        <Card
                            key={question.questionId}
                            sx={{
                                borderRadius: 1,
                                boxShadow: "none",
                                border: "1px solid #e0e0e0",
                                mb: 2,
                                overflow: "hidden",
                                background: "#fff",
                            }}
                        >
                            <Accordion
                                expanded={expanded === question.questionId}
                                // onChange={handleAccordionChange(question.questionId)}
                                sx={{
                                    "&:before": { display: "none" },
                                    boxShadow: "none",
                                }}
                            >
                                <AccordionSummary
                                    sx={{
                                        backgroundColor: "#ffffff",
                                        p: { xs: '2px 8px 2px 8px', sm: 2, md: 2 },
                                        "& .MuiAccordionSummary-content": {
                                            display: "flex",
                                            flexDirection: { xs: 'row', sm: 'row', md: 'row' },
                                            alignItems: "center",
                                            justifyContent: { xs: 'flex-start', sm: 'flex-start', md: 'flex-start' },
                                            flexWrap: "wrap",
                                            gap: { xs: 1, sm: 2, md: 3 },
                                            minWidth: 0,
                                        },
                                    }}
                                >

                                    <Box sx={{ // index + 1
                                        display: "flex", alignItems: "center", width: 25, height: 28, justifyContent: "center", gap: 0.5,
                                        backgroundColor: "#E9EFFD", borderRadius: { xs: '4px', sm: '4px', md: '4px' }, alignSelf: 'baseline',
                                        // color: question?.response_recorded === "correct" ? "#2e7d32" : question?.response_recorded === null ? "#757575" : "#d32f2f",
                                        p: 1.2, fontSize: { xs: 10, sm: 13, md: 13 }, fontWeight: 600, textTransform: "capitalize",
                                    }} >
                                        {index + 1}
                                    </Box>
                                    <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'column', md: 'row' }, flex: 1, justifyContent: { xs: 'flex-start', sm: 'flex-start', md: 'space-around' }, alignItems: { md: 'baseline' }, gap: { xs: 2, sm: 2, md: 5 } }}>
                                        <Box sx={{ // Correct , Not Answered , Incorrect
                                            display: "flex", alignItems: "center", width: { xs: 100, sm: 130, md: 130 }, height: 30, justifyContent: "center", gap: 0.5,
                                            backgroundColor: question?.response_recorded === "correct" ? "#e8f5e9" : question?.response_recorded === null ? "#e3e8ef" : "#ffebee",
                                            color: question?.response_recorded === "correct" ? "#2e7d32" : question?.response_recorded === null ? "#3F3F3F" : "#d32f2f",
                                            px: 1.2, py: 3, borderRadius: { xs: '4px', sm: '4px', md: '4px' }, fontSize: { xs: 9, sm: 14, md: 14 }, fontWeight: 600, textTransform: "capitalize",
                                        }} >
                                            {question?.response_recorded === "correct"
                                                ? "Correct"
                                                : question?.response_recorded === null
                                                    ? "Not Answered"
                                                    : "Incorrect"}
                                            {question?.response_recorded === "correct" ? (
                                                <DoneIcon sx={{ ml: 1, fontSize: 16 }} />
                                            ) : question?.response_recorded === null ? (
                                                <Typography sx={{ ml: 1, fontSize: 18, color: '#3F3F3F' }}>!</Typography>
                                            ) : (
                                                <CloseIcon sx={{ ml: 1, fontSize: 16 }} />
                                            )}

                                        </Box>

                                        <Box id='123' sx={{ // 3 typography
                                            display: "flex",
                                            flexDirection: { xs: "row", sm: "row", md: "row" },
                                            justifyContent: { xs: "flex-start", sm: "flex-start", md: "flex-start" },
                                            alignItems: "center",
                                            columnGap: { xs: 2, sm: 4, md: 6 },
                                            rowGap: 1,
                                            flex: 1,
                                            minWidth: 0,
                                            flexWrap: "wrap",
                                        }}>
                                            <Typography variant="body2" sx={{ fontWeight: 600, color: 'black', fontSize: { xs: 9, sm: 16, md: 14 } }}> {/* Time spent:  */}
                                                Time spent: {
                                                    (
                                                        question?.timeTaken > 1000000
                                                            ? (question.timeTaken / 1000000000).toFixed(2)
                                                            : question?.timeTaken?.toFixed(2)
                                                    )
                                                }s
                                            </Typography>


                                            <Typography variant="body2" sx={{ fontWeight: 600, color: 'black', fontSize: { xs: 9, sm: 16, md: 14 } }}> {/* Selected option: */}
                                                Selected option:{" "}
                                                <Box component="span" sx={{ fontWeight: 600, color: 'inherit' }}>
                                                    {(() => {
                                                        const parsedAnswer =
                                                            typeof question.options === "string"
                                                                ? JSON.parse(question.options)
                                                                : question.options;

                                                        const options = parsedAnswer?.mcqOptions || [];
                                                        const selectedIndex = options.findIndex(
                                                            (opt) => opt.trim() === question.selectedAnswer?.trim()
                                                        );
                                                        const selectedLabel =
                                                            selectedIndex !== -1 ? String.fromCharCode(65 + selectedIndex) : "";

                                                        return (
                                                            <>
                                                                {selectedLabel ? `${selectedLabel} ` : '-'}

                                                            </>
                                                        );
                                                    })()}
                                                </Box>
                                            </Typography>
                                            <Typography variant="body2" sx={{ fontWeight: 600, color: 'black', fontSize: { xs: 9, sm: 16, md: 14 } }}> {/* correct answer */}
                                                Correct answers:{" "}
                                                <Box component="span" sx={{ fontWeight: 600, color: 'inherit' }}>
                                                    {(() => {
                                                        const parsedAnswer =
                                                            typeof question.options === "string"
                                                                ? JSON.parse(question.options)
                                                                : question.options;

                                                        const options = parsedAnswer?.mcqOptions || [];
                                                        const correctAnswers = parsedAnswer?.correctAnswer || [];
                                                        const correctIndex = correctAnswers.findIndex((ans) => ans === true);
                                                        const correctLabel =
                                                            correctIndex !== -1 ? String.fromCharCode(65 + correctIndex) : "";

                                                        return (
                                                            <>
                                                                {correctLabel && `${correctLabel} `}
                                                            </>
                                                        );
                                                    })()}
                                                </Box>
                                            </Typography>
                                        </Box>

                                        <Button //  View Question and Explanation
                                            size="small"
                                            sx={{
                                                color: "#000000ff",
                                                textTransform: "none",
                                                fontWeight: 500,
                                                fontSize: { xs: 9, sm: 14, md: 14 },
                                                borderRadius: { xs: '4px', sm: '4px', md: '4px' },
                                                background: '#eee',
                                                '&:hover': { background: '#eee' },
                                                width: { xs: '100%', sm: 'auto' },
                                                maxWidth: { xs: 180, sm: 280, md: 'unset' },
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                ml: { xs: 0, sm: 0 },
                                                mt: { xs: 0, sm: 0 },
                                                order: { xs: 2, sm: 0 },
                                                alignSelf: { xs: 'flex-start', sm: 'flex-start' },
                                                pl: { xs: 0.5, sm: 3, md: 3 },
                                                pr: { xs: 0.5, sm: 3, md: 3 }
                                            }}
                                            endIcon={<ExpandMoreIcon sx={{ fontSize: 30 }} />}
                                            onClick={() => setExpanded(expanded === question.questionId ? null : question.questionId)}
                                        >
                                            {expanded === question.questionId
                                                ? "Hide Question and Explanation"
                                                : "View Question and Explanation"}
                                        </Button>
                                    </Box>
                                </AccordionSummary>


                                <AccordionDetails
                                    sx={{
                                        backgroundColor: expanded === question.questionId ? '#eee' : '#fff',
                                        p: { xs: 1.5, sm: 3, md: 3 },
                                        border: { xs: '8px solid #fff', sm: '20px solid #fff', md: '20px solid #fff' },
                                        borderRadius: { xs: 2, sm: 3.5, md: 4 }
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: question?.passage
                                                ? { xs: 'column', md: 'column' }
                                                : { xs: 'column', md: 'row' },
                                            alignItems: 'flex-start',
                                            gap: 2,
                                            width: '100%',
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                flex: 1,
                                                display: 'flex',
                                                flexDirection: question?.passage ? { xs: 'column', sm: 'column', md: 'row' } : { xs: 'column', sm: 'column', md: 'column' },
                                                pr: !question?.passage ? { md: 2 } : 0,
                                                minWidth: 0,
                                            }}
                                        >
                                            {
                                                question?.passage && (
                                                    <>
                                                        <Box sx={{ flex: 1 }}>
                                                            <Typography
                                                                variant="body1"
                                                                sx={{ fontWeight: 600, mb: 1, color: '#000' }}
                                                            >
                                                                PASSAGE:
                                                            </Typography>
                                                            <Typography
                                                                dangerouslySetInnerHTML={{ __html: question?.passage }}
                                                                variant="body2"
                                                                sx={{ lineHeight: 1.7, color: '#555', fontSize: { xs: 12, sm: 14, md: 14 } }}
                                                            />
                                                        </Box>

                                                        <Divider orientation="vertical" flexItem sx={{ borderColor: '#ccc', display: { xs: 'none', md: 'block' }, mx: 1, }} />
                                                    </>
                                                )}

                                            <Divider orientation="horizontal" sx={{
                                                borderColor: '#ddd',
                                                display: question?.passage ? { xs: 'block', md: 'none' } : { xs: 'none', md: 'none' },
                                                my: 2,
                                            }} />

                                            <Box
                                                sx={{
                                                    flex: !question?.passage ? 1 : 'unset',
                                                    width: question?.passage ? { xs: '100%', sm: '100%', md: '50%' } : { xs: '100%', sm: '100%', md: '100%' },
                                                    pr: !question?.passage ? { md: 2 } : 0,
                                                    minWidth: 0,
                                                    ml: { xs: 0, sm: 0, md: 1 }
                                                }}
                                            >
                                                <Typography
                                                    variant="body1"
                                                    sx={{ mb: 1, mt: 1, fontWeight: 600, color: '#000' }}
                                                >
                                                    QUESTION:
                                                </Typography>

                                                <Typography
                                                    variant="body2"
                                                    sx={{ mb: 3, lineHeight: 1.7, color: '#333', fontSize: { xs: 12, sm: 14, md: 14 } }}
                                                    dangerouslySetInnerHTML={{ __html: question?.question_text }}
                                                />

                                                <Grid container spacing={1.5} sx={{ mb: 3, flexDirection: 'column' }}>
                                                    {(() => {
                                                        const parsedAnswer =
                                                            typeof question.options === 'string'
                                                                ? JSON.parse(question.options)
                                                                : question.options;
                                                        const options = parsedAnswer?.mcqOptions || [];
                                                        const correctAnswers = parsedAnswer?.correctAnswer || [];

                                                        return options.map((value, index) => {
                                                            const key = String.fromCharCode(65 + index);
                                                            const isCorrect = correctAnswers[index] === true;
                                                            const isSelected = question.selectedAnswer === value;
                                                            const isWrong = isSelected && !isCorrect;

                                                            return (
                                                                <Grid item xs={12} key={key}>
                                                                    <Box
                                                                        sx={{
                                                                            borderRadius: '8px',
                                                                            border: isWrong
                                                                                ? '1.8px solid #d32f2f'
                                                                                : isCorrect
                                                                                    ? '1.8px solid #2e7d32'
                                                                                    : '1px solid #000',
                                                                            p: 1.8,
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'space-between',
                                                                            backgroundColor: isCorrect
                                                                                ? '#e8f5e9'
                                                                                : isWrong
                                                                                    ? '#ffebee'
                                                                                    : '#eee',
                                                                            color: isCorrect
                                                                                ? '#000'
                                                                                : isWrong
                                                                                    ? '#000'
                                                                                    : '#000',
                                                                            transition: 'all 0.2s ease',
                                                                        }}
                                                                    >
                                                                        <Typography
                                                                            variant="body2"
                                                                            sx={{
                                                                                p: 1,
                                                                                fontWeight: 500,
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                fontSize: { xs: 10, sm: 14, md: 14 }
                                                                            }}
                                                                        >
                                                                            <Box sx={{
                                                                                width: { xs: 20, sm: 24, md: 28 }, height: { xs: 20, sm: 24, md: 28 }, minWidth: { xs: 20, sm: 24, md: 28 }, minHeight: { xs: 20, sm: 24, md: 28 }, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 500, fontSize: { xs: 10, sm: 14, md: 14 }, borderRadius: '50%',
                                                                                border: isCorrect ? '2px solid #249935' : isWrong ? '2px solid #B50000' : '1px solid #000',
                                                                                backgroundColor: isCorrect ? '#249935' : isWrong ? '#B50000' : '#F4F4F4',
                                                                                color: isCorrect ? '#fff' : isWrong ? '#fff' : '#000', transition: 'all 0.2s', marginRight: 1.5, mb: '2px'
                                                                            }} >
                                                                                {key}
                                                                            </Box>

                                                                            <span dangerouslySetInnerHTML={{ __html: value }} />
                                                                        </Typography>

                                                                        {isCorrect && (
                                                                            <DoneIcon
                                                                                sx={{ color: '#2e7d32', marginRight: '10px' }}
                                                                            />
                                                                        )}
                                                                        {isWrong && (
                                                                            <CloseIcon sx={{ color: '#d32f2f', marginRight: '10px' }} />
                                                                        )}
                                                                    </Box>
                                                                </Grid>
                                                            );
                                                        });
                                                    })()}
                                                </Grid>
                                            </Box>
                                        </Box>

                                        <Divider sx={{ borderBottomWidth: 'thin', borderColor: '#ccc', marginTop: '0px', marginBottom: '14px', }} orientation="horizontal" flexItem />

                                        {!question?.passage && (
                                            <Divider orientation="vertical" flexItem sx={{ display: { xs: 'none', md: 'block' }, borderColor: '#e0e0e0', mx: 0, my: 0, }} />
                                        )}

                                        {/* Explanation Section */}
                                        <Box
                                            sx={{
                                                flex: 1,
                                                display: 'flex',
                                                flexDirection: 'column',
                                                pl: !question?.passage ? { md: 2 } : 0,
                                                minWidth: 0,
                                            }}
                                        >
                                            <Typography
                                                variant="body1"
                                                sx={{ fontWeight: 600, mb: 1, color: '#143681' }}
                                            >
                                                EXPLANATION:
                                            </Typography>

                                            <Typography
                                                variant="body2"
                                                sx={{ lineHeight: 1.7, color: '#555', fontSize: { xs: 12, sm: 14, md: 14 } }}
                                                dangerouslySetInnerHTML={{ __html: question?.justification }}
                                            />
                                        </Box>
                                    </Box>
                                </AccordionDetails>



                            </Accordion>
                        </Card>
                    ))}
                </Box>
            </>
        );
    };

    const handlePostUserResult = async () => {
        const currentAttemptCount = Chapterdetails?.assessment_results?.[0]?.user_result?.length || 0;
        setOpenConfirmDialog(false);
        setIsLoading(true);
        const endTime = Date.now();
        const timeSpent = (endTime - startTime) / 1000;
        const updated = {
            ...questionTimes,
            [currentIndex]: (questionTimes[currentIndex] || 0) + timeSpent,
        };
        setQuestionTimes(updated);
        await proceedWithSubmission(updated);
        setAssessmentTabIndex(2)
        // setSelectedAttemptIndex(currentAttemptCount);
    };

    const proceedWithSubmission = async (updatedQuestionTimes) => {
        const totalTimeTaken = Object.values(updatedQuestionTimes).reduce(
            (sum, t) => sum + t,
            0
        );

        const formattedSelectedAnswers = questions.map((q, i) => ({
            questionId: q.id,
            index: i,
            selectedAnswer: selectedAnswers[i] || null,
            timeTaken: updatedQuestionTimes[i] || 0,
            multiplier: q?.cognitive_skill_id,
        }));

        const body = {
            type: Chapterdetails?.assessment_type === "English Chapter Test" ? "English" : "Maths",
            assessment_id: Chapterdetails?.id,
            user_id: userInfo?.id,
            user_result: formattedSelectedAnswers,
            date_started: getCurrentTime(),
            date_completed: getCurrentTime(),
            difference_date: totalTimeTaken,
            attemptCount: 0,
            submodules: Chapterdetails?.chapter_description,
            section: location.state?.chapterid,
            last: location.state?.chapterid,
            name: Chapterdetails?.chapter_description,
            description: Chapterdetails?.chapter_description,
            SATtype: "Chapter_Level",
            level: "medium",
            subscribedDate: "",
        };

        const result = await adminServices.postChapterLevelSATResult(body);
        setMarkedForReview({});

        if (result.ok) {
            setShowCongratulationsModal(true);
            setTimeout(() => {
                setIsLoading(false);
                setShowCongratulationsModal(false);
                getChapterDetails()
                setTestView(false);
                setInstructions(false);
                setCalculatorOpen(false);
                setShowModuleComplete(false);
                setSelectedAnswers([]);
                setStartTime('');
                setQuestionTimes([]);
                setTime(0);
                // setCorrectAnswer([]);
                setCurrentIndex(0);
            }, 2000);
        }
    };



    const postAssessmentPrePayment = async () => {
        navigate("/auth/PrePaymentPage", { state: Chapterdetails })
    }


    const nbsp = '\u00A0'; // 4 spaces
    const dataTitle = Chapterdetails?.chapter_description
    const subject = Chapterdetails?.assessment_type === "Maths Chapter Test" ? 'Math' : 'Reading and Writing'
    const assessments = [
        { id: Chapterdetails?.related_chapter_id, title: "Free Attempt", name: `${dataTitle}${nbsp} test -`, data: Chapterdetails },
        { id: Chapterdetails?.related_chapter_id, title: "Attempt 1", name: `${dataTitle}${nbsp} test -`, data: Chapterdetails },
        { id: Chapterdetails?.related_chapter_id, title: "Attempt 2", name: `${dataTitle}${nbsp} test -`, data: Chapterdetails },
        { id: Chapterdetails?.related_chapter_id, title: "Attempt 3", name: `${dataTitle}${nbsp} test -`, data: Chapterdetails },
        { id: Chapterdetails?.related_chapter_id, title: "Attempt 4", name: `${dataTitle}${nbsp} test -`, data: Chapterdetails },
        { id: Chapterdetails?.related_chapter_id, title: "Attempt 5", name: `${dataTitle}${nbsp} test -`, data: Chapterdetails },
    ];


    const attemptcount = Array.isArray(Chapterdetails?.assessment_results) && Chapterdetails.assessment_results.length > 0 ? Chapterdetails.assessment_results[0]?.user_result?.length || 0 : 0;
    const firstFreeAttempt = Chapterdetails?.assessment_results?.length > 0 && Chapterdetails?.assessment_results[0]?.user_result?.length && Chapterdetails?.isPaid !== true

    const TOTAL_ATTEMPTS_ALLOWED = 6;

    const isAllAttemptsCompleted = attemptcount === TOTAL_ATTEMPTS_ALLOWED;

    const isSubscriptionExpired = (validFrom, validTo) => {
        if (!validFrom || !validTo) return false;

        const today = new Date();
        const fromDate = new Date(validFrom);
        const toDate = new Date(validTo);

        const expiredDate = today < fromDate || today > toDate;
        return expiredDate;
    };

    const subscriptionExpired = isSubscriptionExpired(Chapterdetails?.valid_from, Chapterdetails?.valid_to);

    const assessmentResult = Chapterdetails?.assessment_results?.[0];
    const userResultsArray = assessmentResult?.user_result || [];
    // if you are storing dropdown index (0,1,2...) then this works
    const selectedAttemptResult = userResultsArray[selectedAttemptIndex] || [];
    const isSelectedAttemptCompleted = selectedAttemptResult.length > 0;


    const showBuyNowButton =
        ((Chapterdetails?.is_payment === true || Chapterdetails?.is_payment === null) && Chapterdetails?.ispaid === false) ||
        (Chapterdetails?.ispaid === true &&
            (Chapterdetails?.subscription_status === "DELETED" || Chapterdetails?.subscription_status === "CANCELED") &&
            userRole !== 'AUTH_USER');

    return (
        <Box p={3} sx={{ padding: '0 30px !important', background:"white" }}>
            {isLoading ? (
               <AssessmentSkeleton />
            ) : (
                    <>
                        {instructions === false && (
                            <>
                                <div className="mt-16">
                                    <div className="relative w-screen h-[230px] sm:h-[230px] overflow-hidden -mx-4 sm:-mx-6 md:-mx-8">
                                        <img
                                            src={chapterCover}
                                            alt="Assessment Cover"
                                            className="absolute inset-0 w-full h-full object-cover object-center"
                                        />

                                        <div className="absolute top-4 left-4 sm:top-6 sm:left-8 md:left-14 text-white space-y-2 sm:space-y-3 max-w-[90%] sm:max-w-[85%] md:max-w-[80%]">
                                            <button
                                                onClick={handleNavigation}
                                                className="text-xs sm:text-sm flex items-center gap-1 sm:gap-2 hover:underline transition-all"
                                            >
                                                <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
                                                </svg>
                                                Back
                                            </button>

                                            <h1 className="text-xl sm:text-2xl md:text-3xl font-bold leading-snug">
                                                {Chapterdetails?.chapter_description} Test
                                            </h1>

                                            <p className="text-xs sm:text-sm md:text-base opacity-90 leading-relaxed">
                                                Hone your skills to a micro level using our chapter tests. Treat this as a golden opportunity to practice to a finer level in this assessment
                                            </p>

                                            <div className="flex items-center gap-4 sm:gap-6 text-xs sm:text-sm">
                                                <div className="flex items-center gap-1">
                                                    ⭐ <span>4.8</span>
                                                </div>
                                                <div className="flex items-center gap-1">
                                                    <UsersIcon className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
                                                    <span>500+ Attempts</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="w-screen -mx-4 sm:-mx-6 md:-mx-8 ">
                                    {subscriptionExpired && (
                                        <div className="w-full bg-red-500 px-4 py-3 sm:px-6 sm:py-4 text-white font-medium flex items-start gap-3">
                                            <div className="flex items-center ml-8 justify-center pt-0.5 flex-shrink-0">
                                                <BellIcon size={20} className="text-white w-5 h-5" />
                                            </div>
                                            <div className="flex-1">
                                                <p className="font-semibold text-sm sm:text-base">
                                                    Your Assessment Subscription has expired. You can renew this assessment from the <span className="font-bold">Overview</span> tab.
                                                </p>
                                                <p className="text-xs sm:text-sm mt-1 opacity-90">
                                                    Access to this Assessment ended on date. You can renew the assessment from the 'Overview' tab.
                                                </p>
                                            </div>
                                        </div>
                                    )}

                                    {isAllAttemptsCompleted && !subscriptionExpired && (
                                        <div className="w-full bg-[#fdf1ff] px-4  py-3 sm:px-6 sm:py-4 flex items-start gap-3">
                                            <div className="flex items-center ml-8 justify-center pt-0.5 flex-shrink-0">
                                                <WarningIcon className="w-5 h-5" />
                                            </div>
                                            <div className="flex-1">
                                                <p className="font-semibold leading-tight text-black text-sm sm:text-base">
                                                    All attempts completed!
                                                </p>
                                                <p className="text-xs sm:text-sm text-gray-700 mt-1">
                                                    You've used all 6 attempts for this assessment. Purchase again from the <span className="font-bold">Overview</span> tab to get 5 more (+1 Free) more attempts and continue practicing.
                                                </p>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </>
                        )}

            {instructions === false && (
                <div className=" mx-auto px-4 mt-6 mb-6">
                    {/* tabs section */}
                    <div className="mt-4 mb-4  w-full">
                        <div className="flex flex-col md:flex-row md:justify-between">
                            <div className="
                                grid grid-cols-2 gap-2
                                bg-gray-100 rounded-xl p-1
                                w-full sm:w-full md:w-[700px]
                                md:grid-cols-3 md:gap-0
                                ">
                                {AssessmentTabs.map((tab, index) => (
                                    <button
                                        key={index}
                                        onClick={() => handleAssessmentTabChange(index)}
                                        className={`
                                            flex items-center justify-center
                                            h-10 px-3
                                            text-xs sm:text-sm md:text-base
                                            rounded-md
                                            transition-all duration-200
                                            ${assessmentTabIndex === index
                                                ? "bg-white shadow-sm text-black border border-gray-200 font-medium"
                                                : "text-gray-500 hover:text-black"
                                            }
                                        `}
                                    >
                                        {tab}
                                    </button>
                                ))}

                            </div>

                            {/* Right side info */}
                            {/* {showBuyNowButton && (
                                <div className="flex items-center gap-4 mt-4 md:mt-0"> */}
                            {/* <div className="text-sm">
                                        <span className="font-medium">Attempts Left:</span>
                                        <span className="ml-2 text-blue-600 font-bold">
                                            {Chapterdetails?.assessment_results === null ? 5 : (5 - attemptcount)}
                                        </span>
                                    </div> */}
                            {/* <Button
                                        onClick={postAssessmentPrePayment}
                                        variant="contained"
                                        startIcon={<PaymentIcon />}
                                        sx={{
                                            backgroundColor: '#1a73e8',
                                            color: '#fff',
                                            textTransform: 'none',
                                            fontWeight: 'bold',
                                            borderRadius: '6px',
                                            px: 2.5,
                                            py: 1,
                                            '&:hover': {
                                                backgroundColor: '#155ab6',
                                            },
                                        }}
                                    >
                                        Buy Now
                                    </Button>
                                </div>
                            )} */}
                        </div>
                    </div>
                    {/* all 3 Tab Contents  */}
                    {/* Overview Tab */}
                    {assessmentTabIndex === 0 && (


                        <div className="w-full">
                            {/* Assessment Stats Cards */}
                            {/* <div className="w-full "> */}
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 w-full">
                                <StatCard icon={Clock} value="30mins" label="Duration" />
                                <StatCard icon={Document} value="25" label="Questions" />
                                <StatCard icon={Graph} value="Complex" label="Difficulty Level" />
                                <StatCard icon={Bolt} value="English" label="Language of Assessment" />
                            </div>
                            {/* </div> */}
                            <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-6 w-full">
                                {/* Left Column - What you'll get */}
                                <div className="md:col-span-2 border rounded-xl p-6 bg-white shadow-sm">
                                    <h2 className="text-lg font-semibold mb-4">What you'll get</h2>

                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-4 gap-x-6">
                                        <div className="flex items-center gap-2 text-sm text-gray-700">
                                            <CheckCircleIcon className="w-5 h-5 text-[#32D74B]" />
                                            <span>5 Full Attempts + 1 Free Attempt</span>
                                        </div>

                                        <div className="flex items-center gap-2 text-sm text-gray-700">
                                            <CheckCircleIcon className="w-5 h-5 text-[#32D74B]" />
                                            <span>Detailed Analytics</span>
                                        </div>

                                        <div className="flex items-center gap-2 text-sm text-gray-700">
                                            <CheckCircleIcon className="w-5 h-5 text-[#32D74B]" />
                                            <span>Solutions & Explanations</span>
                                        </div>

                                        <div className="flex items-center gap-2 text-sm text-gray-700">
                                            <CheckCircleIcon className="w-5 h-5 text-[#32D74B]" />
                                            <span>Performance Report</span>
                                        </div>

                                        <div className="flex items-center gap-2 text-sm text-gray-700">
                                            <CheckCircleIcon className="w-5 h-5 text-[#32D74B]" />
                                            <span>Performance analytics and insights</span>
                                        </div>

                                        <div className="flex items-center gap-2 text-sm text-gray-700">
                                            <CheckCircleIcon className="w-5 h-5 text-[#32D74B]" />
                                            <span>Mobile Friendly</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="border rounded-xl p-6 bg-white shadow-sm flex flex-col justify-between">
                                    <div>
                                        {isAssessmentUnpaid && (
                                            <div className="flex flex-wrap items-center gap-2 mb-3">
                                                {/* Save 50% chip */}
                                                <span className="inline-flex items-center gap-1 bg-pink-100 text-pink-600 text-xs font-semibold px-3 py-1 rounded-full">
                                                    ★ Save 50%
                                                </span>

                                                {/* Free Attempt chip */}
                                                <span className="inline-flex items-center bg-blue-100 text-blue-700 text-xs font-semibold px-3 py-1 rounded-full">
                                                    {firstFreeAttempt ? '1 Free Attempt Exhausted' : '1 Free Attempt'}
                                                </span>
                                            </div>
                                        )}


                                        {(isAssessmentPaid) && !(Chapterdetails?.subscription_status === "DELETED" || Chapterdetails?.subscription_status === "CANCELED") && (
                                            <div className="mb-4">
                                                <p className="text-sm text-gray-600 mb-1">
                                                    {'Attempts Completed'}
                                                </p>
                                                <p className="text-3xl font-bold text-blue-600">
                                                    {attemptcount} / {TOTAL_ATTEMPTS_ALLOWED}
                                                </p>
                                            </div>
                                        )}

                                        {isAssessmentUnpaid && (
                                            <div className="mb-5">
                                                <div className="flex items-baseline gap-3">
                                                    <span className="text-4xl font-bold text-gray-900">
                                                        {computedViewPrice}
                                                    </span>
                                                    {originalPrice && (
                                                        <span className="text-lg text-gray-400 line-through">
                                                            ${originalPrice}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        )}

                                        {subscriptionExpired ? (
                                            <button
                                                onClick={postAssessmentPrePayment}
                                                disabled={isLoading}
                                                className="w-full bg-red-500 hover:bg-red-600 text-white py-3 rounded-lg text-sm font-semibold mb-4 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                                            >
                                                {isLoading ? 'Please wait...' : 'Renew Assessment'}
                                            </button>
                                        ) : (
                                            ((Chapterdetails?.is_payment === true || Chapterdetails?.is_payment === null) && Chapterdetails?.ispaid === false) ||
                                                (Chapterdetails?.ispaid === true && (Chapterdetails?.subscription_status === "DELETED" || Chapterdetails?.subscription_status === "CANCELED")) ? (
                                                <>
                                                    <button
                                                        onClick={() =>
                                                            setAssessmentTabIndex(firstFreeAttempt ? 2 : 1)
                                                        }

                                                        disabled={isLoading}
                                                        className="w-full bg-pink-600 hover:bg-pink-700 text-white py-3 rounded-lg text-sm font-semibold mb-3 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                                                    >{firstFreeAttempt ? (isLoading ? 'Please wait...' : 'Free Test Analysis') :
                                                        (isLoading ? 'Please wait...' : 'Start Free Test')}
                                                    </button>

                                                    <button
                                                        onClick={postAssessmentPrePayment}
                                                        disabled={isLoading}
                                                        className="w-full bg-white border border-gray-300 hover:bg-gray-50 text-gray-700 py-3 rounded-lg text-sm font-semibold mb-4 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                                                    >
                                                        {isLoading ? 'Please wait...' : 'Buy Full Access'}
                                                    </button>
                                                </>
                                            ) : (
                                                <button
                                                    onClick={() => setAssessmentTabIndex(1)}
                                                    disabled={isLoading}
                                                    className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg text-sm font-semibold mb-4 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                                                >
                                                    {isLoading ? 'Loading...' : attemptcount === 6 ? 'View Attempted' : attemptcount > 0 ? 'Continue Your Test' : 'Start Test'}
                                                </button>
                                            )
                                        )}

                                        {/* Details Section */}
                                        <div className="space-y-3 text-sm border-t pt-4">
                                            <div className="flex justify-between text-gray-700">
                                                <span>Valid till</span>
                                                <span className="font-medium">
                                                    {Chapterdetails?.validTo
                                                        ? moment(Chapterdetails.validTo).format("LL")
                                                        : '1 Month'}
                                                </span>
                                            </div>

                                            <div className="flex justify-between text-gray-700">
                                                <span>Attempts Included</span>
                                                <span className="font-medium">
                                                    {Chapterdetails?.total_attempts || '06'}
                                                </span>
                                            </div>

                                            {Chapterdetails?.ispaid &&
                                                Chapterdetails?.subscription_status !== "DELETED" &&
                                                Chapterdetails?.subscription_status !== "CANCELED" && (
                                                    <div className="flex justify-between text-gray-700">
                                                        <span>Purchased on</span>
                                                        <span className="font-medium">
                                                            {moment(Chapterdetails?.valid_from).format("LL")}
                                                        </span>
                                                    </div>
                                                )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Attempts Tab */}
                    {assessmentTabIndex === 1 && (
                        <div
                            id="box1"
                            className="flex flex-col w-[100%] gap-6 p-4 sm:p-4 md:p-4 bg-white rounded-xl border border-gray-200"
                        >
                            <div id="box2" className="flex flex-col gap-6">
                                <h2 className="text-2xl font-semibold">Your Attempts</h2>
                                {assessments?.length > 0 && assessments.map((assessment, index) => {
                                    let borderColor = '#dddada';
                                    let bgColor = '#f5f5f5';

                                    const assessmentResult = Chapterdetails?.assessment_results?.[0];
                                    const userResultsArray = assessmentResult?.user_result || [];

                                    const safeResults = Array.from({ length: assessments.length }, (_, i) => userResultsArray[i] || []);
                                    const userResult = safeResults[index];
                                    const isAttempted = userResult && userResult.length > 0;

                                    const firstUnattemptedIndex = safeResults.findIndex(r => !r || r.length === 0);

                                    const isPaid = Chapterdetails?.is_payment === true && Chapterdetails?.ispaid === true;
                                    const isTrial = Chapterdetails?.is_payment === true && Chapterdetails?.ispaid === false;

                                    let isButtonEnabled = false;

                                    if (index === 0) {
                                        isButtonEnabled = true;
                                    }
                                    else if (isPaid) {
                                        if (firstUnattemptedIndex === index) {
                                            isButtonEnabled = true;
                                        }
                                    }
                                    else {
                                        isButtonEnabled = false;
                                    }

                                    if (isAttempted && userResult.every(item => item.response_recorded === "correct")) {
                                        borderColor = '#40C057';
                                        bgColor = '#EAFBEA';
                                    } else if (isAttempted && userResult.every(item => item.response_recorded === "incorrect")) {
                                        borderColor = '#FA5252';
                                        bgColor = '#FCEBEA';
                                    }

                                    return (
                                        <Box id='box12346'
                                            key={assessment.id}
                                            sx={{
                                                borderRadius: "4px",
                                                width: '99%',
                                                padding: '10px !important',
                                                // margin: '5px auto 0 !important',
                                                backgroundColor: bgColor,
                                                // border: `1px solid ${borderColor}`,
                                            }}
                                        >
                                            <Box sx={{ display: "flex", flexDirection: { xs: 'column', sm: 'row', md: 'row' }, justifyContent: "space-between", padding: '8px 15px', alignItems: { xs: 'left', sm: 'center', md: 'center' } }}>
                                                <Box sx={{ flex: 1, gap: 2 }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, fontWeight: 'bold', fontSize: { xs: 12, sm: 14, md: 16 }, marginBottom: '8px', }} >
                                                        <span className="font-semibold text-[14px] md:text-[16px] w-[130px] ">
                                                            {assessment?.title}
                                                        </span>
                                                        {isAttempted && (
                                                            <div className="flex items-center gap-2">
                                                                <span className="flex items-center gap-1 text-[12px] font-medium text-green-600 justify-self-start">
                                                                    <span className="w-1.5 h-1.5 rounded-full bg-green-600" />
                                                                    Completed
                                                                </span>
                                                            </div>
                                                        )}
                                                    </Box>


                                                    <Box sx={{ display: 'flex', alignItems: { xs: 'left', sm: 'center', md: 'center' }, gap: { xs: 0.5, sm: 2, md: 2 }, color: '#666', flexDirection: { xs: 'column', sm: 'row', md: 'row' } }}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                            <HelpOutlineIcon sx={{ fontSize: '16px' }} />
                                                            <Typography variant="body2" sx={{ fontSize: { xs: 12, sm: 14, md: 16 } }}>25 questions</Typography>
                                                        </Box>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                            <AccessTimeIcon sx={{ fontSize: '16px' }} />
                                                            <Typography variant="body2" sx={{ fontSize: { xs: 12, sm: 14, md: 16 } }}>
                                                                {'30 mins'}
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                </Box>

                                                {/* ---------- RIGHT SIDE ---------- */}
                                                {isAttempted ? (
                                                    <Button
                                                        variant="outlined"
                                                        onClick={() => handleViewAnalysis(assessment, index)}
                                                        sx={{
                                                            borderColor: "#3B82F6",
                                                            borderRadius: '4px !important',
                                                            color: "#3B82F6",
                                                            padding: '4px 18px !important',
                                                            "&:hover": {
                                                                backgroundColor: "#3B82F6",
                                                                color: "#fff",
                                                                borderColor: '#3B82F6'
                                                            },
                                                            mt: { xs: 1, sm: 0, md: 0 },
                                                            fontSize: { xs: 12, sm: 14, md: 16 },
                                                        }}
                                                    >
                                                        View Analysis
                                                    </Button>
                                                ) : (
                                                        <Tooltip
                                                            title={
                                                                subscriptionExpired
                                                                    ? "Your subscription has expired. Please renew to access this assessment."
                                                                    : isButtonEnabled
                                                                        ? (index === 0 ? "Free attempt – start now" : "Click to start this test")
                                                                        : (isPaid ? "Please complete the previous test to access this attempt!" : "Please purchase this test to access the attempts!")
                                                            }
                                                        >
                                                            <Box sx={{ display: 'inline-block', width: { xs: '100%', sm: 'auto' } }}>
                                                                <button
                                                                    onClick={() => !subscriptionExpired && isButtonEnabled && handleStartTest(assessment)}
                                                                    disabled={!isButtonEnabled || subscriptionExpired}
                                                                    className={`
                                                                        inline-flex items-center justify-center gap-2
                                                                        px-4 py-2
                                                                        text-xs sm:text-sm
                                                                        font-semibold
                                                                        rounded-md
                                                                        transition-colors duration-200
                                                                        ${subscriptionExpired || !isButtonEnabled
                                                                            ? 'bg-gray-300 text-gray-400 cursor-not-allowed'
                                                                            : 'bg-blue-500 hover:bg-blue-600 text-white'
                                                                        }
                                                                    `}
                                                                >
                                                                    {(!isButtonEnabled && isPaid === false) || subscriptionExpired ? (
                                                                        <LockOutlinedIcon className="text-gray-400 text-sm" />
                                                                    ) : null}
                                                                    Start Now
                                                                </button>
                                                            </Box>
                                                        </Tooltip>
                                                )}
                                            </Box>
                                        </Box>
                                    );
                                })}
                            </div>
                        </div>
                    )}

                    {/* Analytics Tab */}
                    {assessmentTabIndex === 2 && (
                        <div className="w-full">
                            <div className="flex justify-start mb-4">
                                <select
                                    className="border rounded-md px-3 py-2 text-sm"
                                    value={selectedAttemptIndex}
                                    onChange={(e) => setSelectedAttemptIndex(Number(e.target.value))}
                                >
                                    {assessments.map((attempt, idx) => (
                                        <option key={idx} value={idx}>
                                            {attempt.title}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {!isSelectedAttemptCompleted ? (
                                // <div className="bg-white border rounded-xl p-6 shadow-sm text-center">
                                //     <h2 className="text-lg font-semibold">Attempt Not Completed</h2>
                                //     <p className="text-sm text-gray-600 mt-2">
                                //         You have not completed this attempt yet. Please complete it to view Analytics.
                                //     </p>
                                // </div>

                                <div className="bg-white border border-gray-200 rounded-xl p-8 shadow-sm flex flex-col items-center text-center gap-4">
                                    <img src={analysisNotAttempted} alt="Attempt not completed" className="w-40 h-50" />
                                    <Typography variant="h6" sx={{ fontWeight: 700 }}> Please complete the attempt to get analytics</Typography>
                                </div>
                            ) : (
                                <div className="bg-white border rounded-xl p-6 shadow-sm">
                                    <Typography
                                        variant="h4"
                                        sx={{fontWeight: 700, fontSize: { xs: '18px', sm: '32px', md: '32px' } }}
                                    >
                                        Your Practice Score Report
                                    </Typography>

                                    <ScoreCard />

                                    <Box sx={{ mt: 2, mb: 2 }}>
                                        <QuestionWiseAnalysis />
                                    </Box>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            )}



            {instructions === true && testView === false && <>
                <Box display="flex" gap={1} flexWrap="wrap" mb={4} mt={10}>
                    <Box className="practiceTimeInstructions" sx={{ mx: "auto", p: 2, textAlign: "center" }}>
                        <Typography variant="h5" fontWeight="bold" sx={{ mb: 2 }}>
                            {`${Chapterdetails?.chapter_description && Chapterdetails?.chapter_description} Test`}
                        </Typography>


                        <Card variant="outlined" sx={{ textAlign: "left" }}>
                            <CardContent>
                                <Box style={{ display: 'flex', alignItems: 'center' }}>
                                    <HourglassTopIcon className='newiconDesign' />
                                    <Typography style={{ display: 'inline', marginTop: '10px' }} variant="h6" className='topicHeading' fontWeight="bold">{"Timings"}</Typography>
                                </Box>
                                <Typography style={{ paddingLeft: '50px' }} variant="body2">
                                    <ul style={{ marginTop: '8px', marginBottom: '0', paddingLeft: '20px' }}>
                                        <li>{"The"} <strong>{`${Chapterdetails?.chapter_description} `}</strong> {"Chapter Test is"} <strong>{"30 minutes"}</strong> {"long."}</li>
                                        <li>{"It contains 25 questions."}</li>
                                        <li>{"You can pause at any time, but the timer will not reset once started."}</li>
                                    </ul>
                                </Typography>
                                <Box style={{ display: 'flex', alignItems: 'center', marginTop: '15px' }}>
                                    <CoffeeIcon className='newiconDesign' />
                                    <Typography style={{ display: 'inline', marginTop: '10px' }} variant="h6" className='topicHeading' fontWeight="bold">{"Breaks"}</Typography>
                                </Box>
                                <Typography style={{ paddingLeft: '50px' }} variant="body2">
                                    <ul style={{ marginTop: '8px', marginBottom: '0', paddingLeft: '20px' }}>
                                        <li>{"Chapter tests are short and do not include breaks."}</li>
                                        {/* <li>{"There is only one test."}</li> */}
                                    </ul>
                                </Typography>
                                <Box style={{ display: 'flex', alignItems: 'center', marginTop: '15px' }}>
                                    <InsightsIcon className='newiconDesign' />
                                    <Typography style={{ display: 'inline', marginTop: '10px' }} variant="h6" className='topicHeading' fontWeight="bold">{"Scores & Analytics"}</Typography>
                                </Box>
                                <Typography style={{ paddingLeft: '50px' }} variant="body2">
                                    <ul style={{ marginTop: '8px', marginBottom: '0', paddingLeft: '20px' }}>
                                        <li>{"Your score will be available immediately after completing the test."}</li>
                                        <li>{"Analytics will highlight your performance for this chapter, helping you identify strengths and areas for improvement."}</li>
                                    </ul>
                                </Typography>
                                <Box style={{ display: 'flex', alignItems: 'center', marginTop: '15px' }}>
                                    <PsychologyIcon className='newiconDesign' />
                                    <Typography style={{ display: 'inline', marginTop: '10px' }} variant="h6" className='topicHeading' fontWeight="bold">{"Best Practice"}</Typography>
                                </Box>
                                <Typography style={{ paddingLeft: '50px' }} variant="body2">
                                    <ul style={{ marginTop: '8px', marginBottom: '0', paddingLeft: '20px' }}>
                                        <li>{"Treat this chapter test as a focused SAT practice session."}</li>
                                        <li>{"Choose a quiet space and aim to finish in one sitting to simulate real test conditions."}</li>
                                    </ul>
                                </Typography>
                            </CardContent>
                        </Card>
                        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3, marginBottom: { xs: '20px !important', sm: '20px !important', md: '0px !important' } }}>
                            <Button variant="outlined" sx={{
                                backgroundColor: '#fff',
                                color: '#3F3F3F',
                                borderWidth: '1.5px',
                                borderColor: '#3F3F3F !important',
                                borderRadius: '6px',
                                '&:hover': {
                                    backgroundColor: '#3F3F3F',
                                    color: '#fff'
                                }
                            }}
                                onClick={onBack}> <ArrowBackIcon />{"Back"}</Button>
                            <Button variant="contained" style={{ backgroundColor: '#225AD6', color: '#fff', borderRadius: '6px' }}
                                onClick={onStartTest}>{"Start Test"}<ArrowForwardIcon /></Button>
                        </Box>
                    </Box>
                </Box>
            </>}

            {instructions === true && testView === true && <>
                <Box display="flex" gap={0} flexWrap="wrap" mb={0} marginTop="75px">
                    <>
                        <Box sx={{ width: '100%', backgroundColor: "#d2daff" }}>
                            {(isLoading) ? <br /> :
                                <Box id="topicHead" sx={{ display: 'flex', flexDirection: { md: 'row', sm: "column", xs: "column" }, justifyContent: 'space-between', width: '100%', maxHeight: '60px' }}>
                                    <Box sx={{}}>
                                        {Chapterdetails?.assessment_type === "English Chapter Test" ? (
                                            <>
                                                <Typography
                                                    sx={{
                                                        padding: '10px 0px 0px 40px',
                                                        fontSize: { xs: '20px', md: '22px' },
                                                        fontWeight: { xs: 600, md: 700 },
                                                        paddingTop: '0px', position: 'relative', top: "3px"
                                                    }}
                                                    variant="h5"
                                                >
                                                    Reading and Writing
                                                </Typography>

                                                <Dialog
                                                    open={openDrop}
                                                    onClose={() => setOpendrop(false)}
                                                    fullWidth
                                                    maxWidth="sm"
                                                    className='dialogWithArrow'
                                                    PaperProps={{
                                                        sx: {
                                                            zIndex: 1105,
                                                            position: 'absolute',
                                                            left: '1vh',
                                                            top: '160px',
                                                            m: 0
                                                        },

                                                    }}
                                                >

                                                    <DialogContent>
                                                        <Typography>
                                                            {"The essay gives you an opportunity to show how effectively you can read and comprehend a passage and write an essay analyzing the passage. In your essay, you should demonstrate that you have read the passage carefully, present a clear and logical analysis, and use language precisely."}
                                                        </Typography>
                                                        <Button
                                                            onClick={() => setOpendrop(false)}
                                                            variant="contained"
                                                            sx={{
                                                                background: "#ff9800", color: "#fff", borderRadius: "5px",
                                                                float: 'right',
                                                                marginTop: '20px',

                                                                "&:hover": {
                                                                    background: "#d3d3d3",
                                                                    color: "#444"
                                                                }
                                                            }}
                                                        >
                                                            {"Close"}
                                                        </Button>
                                                    </DialogContent>
                                                </Dialog>

                                            </>
                                        ) :
                                            <Typography
                                                sx={{
                                                    padding: '0px 0px 0px 40px',
                                                    fontSize: { xs: '20px', md: '22px' },
                                                    fontWeight: { xs: 600, md: 700 },
                                                    paddingTop: '0px', position: 'relative', top: "3px"
                                                }}
                                                variant="h6">{/* {"Section 2: Math"} */}
                                                Math
                                            </Typography>}
                                        <Typography
                                            variant="text"
                                            sx={{
                                                textTransform: "none",
                                                fontSize: "17px",
                                                float: 'left',
                                                top: '-7px',
                                                cursor: 'pointer',
                                                position: 'relative',
                                                color: '#000',
                                                fontWeight: '500',
                                                paddingLeft: '40px'
                                            }}
                                            onClick={handleClick}>
                                            {"Directions"}<KeyboardArrowDownIcon style={{ position: 'relative', color: '#4a4a4a', fontSize: '24px' }} />
                                        </Typography>
                                        <Popover

                                            //   id={id}
                                            open={open}
                                            PaperProps={{
                                                sx: {
                                                    width: Chapterdetails?.assessment_type === "English Chapter Test" ? 'auto' : '75vw',
                                                    maxWidth: '90vw',
                                                },
                                            }}
                                            anchorEl={anchorEl}
                                            onClose={handleClose}
                                            anchorOrigin={{
                                                vertical: 'bottom',
                                                horizontal: 'left',

                                            }}
                                        >
                                            {Chapterdetails?.assessment_type === "English Chapter Test" ? (
                                                <Typography sx={{ p: 2, maxWidth: '550px', }}> The questions in this section address several important reading and writing skills. Each question includes one or more passages, which may include a table or graph. Read each passage and question carefully and then choose the best answer to the question based on the passage(s). All questions in this section are multiple-choice with four answer choices. Each question has a single best answer.
                                                </Typography>) : (
                                                <Typography sx={{ p: 2 }}>
                                                    The questions in this module will test all levels of your math skills.
                                                    <br /><br />
                                                    The use of a simple calculator is permitted for all questions. You can click on the calculator icon to start using the calculator.
                                                    <br /><br />
                                                    If the question does not specify, you should assume:
                                                    <br />
                                                    &nbsp;&nbsp;&bull; All variables and expressions represent real numbers.
                                                    <br />
                                                    &nbsp;&nbsp;&bull; The figures provided are drawn to scale.
                                                    <br />
                                                    &nbsp;&nbsp;&bull; All figures lie in a plane.
                                                    <br />
                                                    &nbsp;&nbsp;&bull; The domain of a given function "f" is the set of all real numbers "x" for which "f(x)" is a real number.
                                                    <br /><br />
                                                    Every question in this module is a multiple-choice based question and has a single correct answer.
                                                    You are expected to solve each problem and choose the correct one.
                                                    <br /><br />
                                                    The timer is set on the server after your test starts, and the test will be auto submitted after the timer runs out.
                                                    You can submit the test within the test if you are satisfied with your answers.
                                                </Typography>)}
                                            <Button style={{
                                                float: 'right', marginRight: '20px',
                                                marginBottom: '10px',
                                                border: '1px solid'
                                            }} onClick={handleClose}>Close</Button>
                                        </Popover>

                                    </Box>
                                    <Box sx={{ maxHeight: { md: '60px', sm: '70px' }, width: { md: '20%', sm: '99vw', justifyItems: 'center' } }}>
                                        <Typography variant="h6" sx={{
                                            fontWeight: "bold", position: 'relative', top: '5px',
                                            ...(mobileLandscape ? { marginLeft: "-90px", } : { marginLeft: '0px' })
                                        }}>{formatTimeTimer(time)}</Typography>


                                    </Box>
                                    <Box sx={{ visibility: { md: 'visible', sm: 'visible' }, alignContent: 'center', display: { sm: "block" }, width: { md: '20%', sm: '99vw' } }}>

                                        {Chapterdetails?.assessment_type === "Maths Chapter Test" &&
                                            <Tooltip title="Calculator">
                                                <Button variant='outlined' id='CalculatorBtn' onClick={handleCalculatorOpen}
                                                    sx={{
                                                        borderRadius: '4px', float: 'right', color: '#1976d2', fontSize: '16px', marginRight: '5px', padding: '3px 12px',
                                                        borderColor: '#1976d2', '&:hover': {
                                                            borderRadius: '4px',
                                                            borderColor: '#1976d2', backgroundColor: 'rgba(25, 118, 210, 0.04)'
                                                        }
                                                    }}>


                                                    <img alt='calculator' src={IconCalculator} style={{ width: '27px', height: '27px', marginLeft: '4px' }} />

                                                </Button>
                                            </Tooltip>}

                                    </Box>
                                </Box>}
                            {Chapterdetails?.assessment_type === "English Chapter Test" ?
                                <Grid id="QuestionPanel" container sx={{ flex: 1, padding: '0px 8px' }}>
                                    {isLoading ?
                                        <Grid sx={{
                                            padding: 1, backgroundColor: "#ffffff",
                                            paddingTop: '200px',
                                            width: '100%',
                                            paddingRight: '0px',
                                            marginTop: '60px',
                                            paddingleft: '0px',
                                            height: 'Calc(100vh - 225px)',
                                            overflowX: 'hidden',
                                            overflowY: 'auto',
                                        }}>

                                            <LottieLoading loading={isLoading} />
                                            {showModuleComplete && (
                                                <Box
                                                    sx={{
                                                        position: 'fixed',
                                                        top: 0,
                                                        left: 0,
                                                        right: 0,
                                                        bottom: 0,
                                                        backgroundColor: 'rgba(255, 255, 255, 0.95)',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        zIndex: 9999,
                                                        padding: '20px',
                                                        textAlign: 'center'
                                                    }}
                                                >
                                                    <Typography variant="h4" sx={{ color: '#909bd7', marginBottom: 2, fontWeight: '500' }}>
                                                        This Module Is Over
                                                    </Typography>
                                                    <Typography variant="body1" sx={{ marginBottom: 2, fontWeight: '500' }}>
                                                        All your work has been saved
                                                    </Typography>
                                                    <Typography variant="body1" sx={{ marginBottom: 1, fontWeight: '500' }}>
                                                        You'll move on automatically in just a moment.
                                                    </Typography>
                                                    <Typography variant="body1" sx={{ color: 'red' }}>
                                                        Do not refresh this page or quit the app.
                                                    </Typography>
                                                </Box>
                                            )}
                                        </Grid> :
                                        <>
                                            <Grid item sm={12} md={gridLeft} id="gridLeftSection" sx={{
                                                padding: 1, backgroundColor: "#ffffff", borderRight: "5px solid #7d7d7d",
                                                paddingTop: '35px',
                                                paddingRight: '50px',
                                                paddingLeft: '35px',
                                                position: 'relative',
                                                paddingleft: '50px',
                                                height: 'Calc(100vh - 200px)',
                                                overflowX: 'hidden',
                                                overflowY: 'auto',
                                            }}>

                                                <Typography dangerouslySetInnerHTML={{ __html: currentQuestion?.passage }}
                                                    style={{ userSelect: "none" }}
                                                    onCopy={(e) => e.preventDefault()}
                                                    onContextMenu={(e) => e.preventDefault()} />

                                                <Box id="LaunchIcon" sx={{
                                                    boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px', height: '40px',
                                                    width: '40px',
                                                    borderRadius: '50%',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    cursor: 'pointer',
                                                    marginBottom: '10px',
                                                    color: '#adadad',
                                                    top: '8px',
                                                    right: '14px',
                                                    position: 'absolute'
                                                }} onClick={handleGridLeft}>
                                                    <LaunchIcon style={{ scale: '1.1' }} />
                                                </Box>

                                            </Grid>
                                            <Grid item sm={12} md={gridRight} sx={{
                                                padding: 1, backgroundColor: "#f9f9f9",
                                                paddingTop: '8px',
                                                paddingRight: '39px',
                                                position: 'relative',
                                                paddingLeft: '0px',
                                                height: 'Calc(100vh - 200px)',
                                                overflowX: 'hidden',
                                                overflowY: 'auto',
                                                display: 'flex',
                                            }}>
                                                <Box id="LaunchIconRight" onClick={handleGridRight} sx={{
                                                    boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px', height: '40px',
                                                    minWidth: '40px',
                                                    borderRadius: '50%',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    cursor: 'pointer',
                                                    marginBottom: '10px',
                                                    color: '#adadad',
                                                    top: '0px',
                                                    left: '14px',
                                                    position: 'sticky'
                                                }}>
                                                    <LaunchIcon style={{ transform: 'rotate(270deg)', scale: '1.1' }} />
                                                </Box>
                                                {currentQuestion && (
                                                    <Box className="assessmentQuestionPanel" sx={{ paddingLeft: "25px !important", paddingTop: "25px !important", flex: '2' }}>

                                                        <Box
                                                            sx={{
                                                                padding: '4px',
                                                                backgroundColor: "#f0f0f0",
                                                                borderRadius: '2px',
                                                                textAlign: "center",
                                                                borderBottom: '3px dashed #000000c9',
                                                                paddingLeft: { sx: 0, md: "50px" }
                                                            }}
                                                        >
                                                            <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "space-between",
                                                                    gap: 1,
                                                                }}
                                                            >
                                                                <Box
                                                                    sx={{
                                                                        display: "inline-block",
                                                                        padding: "4px 10px !important",
                                                                        backgroundColor: "black",
                                                                        borderRadius: "2px",
                                                                        marginBottom: 0,
                                                                    }}
                                                                >
                                                                    <Typography variant="subtitle1" sx={{ fontWeight: "bold", color: "white" }}>
                                                                        {currentIndex + 1}
                                                                    </Typography>
                                                                </Box>

                                                                <Button
                                                                    onClick={() => {
                                                                        if (markedForReview[currentIndex]) {
                                                                            handleBookmarkFalse(currentIndex);
                                                                        } else {
                                                                            handleBookmarkTrue(currentIndex);
                                                                        }
                                                                    }}
                                                                    className="MarkBtn"
                                                                    sx={{
                                                                        minWidth: "auto",
                                                                        color: '#1976d2',
                                                                    }}
                                                                >
                                                                    {markedForReview[currentIndex] ? (
                                                                        <BookmarkIcon color="#1976d2" />
                                                                    ) : (
                                                                        <BookmarkBorderIcon color="#1976d2" />
                                                                    )}
                                                                    {markedForReview[currentIndex] ? 'Marked for Review' : 'Mark for Review'}
                                                                </Button>
                                                                <Button onClick={() => handleClearResponse()} sx={{ minWidth: "auto", color: '#1976d2', lineHeight: '1.2', }} className="MarkBtn">
                                                                    Clear response</Button>
                                                            </Box>
                                                        </Box>
                                                        <Typography style={{ justifySelf: 'start', userSelect: "none", margin: "10px 0" }}
                                                            dangerouslySetInnerHTML={{ __html: currentQuestion?.question_text }}

                                                            onCopy={(e) => e.preventDefault()}
                                                            onContextMenu={(e) => e.preventDefault()}
                                                        />
                                                        {parsedOptions && parsedOptions?.map((option, index) => (
                                                            <Button
                                                                key={index}
                                                                variant="contained"
                                                                fullWidth
                                                                sx={{
                                                                    marginTop: 1,
                                                                    fontWeight: "400",
                                                                    backgroundColor: "white",
                                                                    color: "black",
                                                                    lineHeight: '1.2',
                                                                    justifyContent: 'start',
                                                                    borderRadius: '4px',
                                                                    padding: '17px 20px',
                                                                    border: selectedAnswers[currentIndex] === option ? "3px solid #4caf50" : "1px solid #ccc",
                                                                    "&:hover": {
                                                                        backgroundColor: "#f1f1f1",
                                                                    }
                                                                }}
                                                                onClick={() => handleOptionSelect(option, index)}
                                                            >
                                                                <span style={{
                                                                    border: '1px solid #aaa',
                                                                    borderRadius: '50%',
                                                                    fontWeight: '400',
                                                                    padding: '7px',
                                                                    height: '23px',
                                                                    width: '23px',
                                                                    display: 'flex',
                                                                    justifyContent: 'center',
                                                                    alignItems: 'center',
                                                                    marginRight: '15px',
                                                                }}>{String.fromCharCode(97 + index)}</span>
                                                                <span dangerouslySetInnerHTML={{ __html: option }} />

                                                            </Button>
                                                        ))}
                                                    </Box>
                                                )}
                                            </Grid> </>}
                                </Grid> :
                                <Grid
                                    container
                                    justifyContent="center"
                                    alignItems="center"
                                    style={{ height: Chapterdetails?.assessment_type === "English Chapter Test" ? 'Calc(100vh - 208px)' : 'Calc(100vh - 200px)', textAlign: "center", alignItems: 'baseline' }}
                                >
                                    {
                                        isLoading ?
                                            <Grid sx={{
                                                padding: 1, backgroundColor: "#ffffff",
                                                paddingTop: '200px',
                                                width: '100%',
                                                paddingRight: '0px',
                                                marginTop: '60px',
                                                paddingleft: '0px',
                                                height: 'Calc(100vh - 180px)',
                                                overflowX: 'hidden',
                                                overflowY: 'auto',
                                            }}>
                                                <LottieLoading loading={isLoading} />
                                                {showModuleComplete && (
                                                    <Box
                                                        sx={{
                                                            position: 'fixed',
                                                            top: 0,
                                                            left: 0,
                                                            right: 0,
                                                            bottom: 0,
                                                            backgroundColor: 'rgba(255, 255, 255, 0.95)',
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            zIndex: 9999,
                                                            padding: '20px',
                                                            textAlign: 'center'
                                                        }}
                                                    >
                                                        <Typography variant="h4" sx={{ color: '#909bd7', marginBottom: 2, fontWeight: '500' }}>
                                                            This Module Is Over
                                                        </Typography>
                                                        <Typography variant="body1" sx={{ marginBottom: 2, fontWeight: '500' }}>
                                                            All your work has been saved
                                                        </Typography>
                                                        <Typography variant="body1" sx={{ marginBottom: 1, fontWeight: '500' }}>
                                                            You'll move on automatically in just a moment.
                                                        </Typography>
                                                        <Typography variant="body1" sx={{ color: 'red' }}>
                                                            Do not refresh this page or quit the app.
                                                        </Typography>
                                                    </Box>
                                                )}
                                            </Grid> :
                                            currentQuestion && (
                                                <Box
                                                    sx={{
                                                        width: {
                                                            xs: "90%", sm: "80%", md: "70%", lg: "68%", xl: "85%"
                                                        },
                                                        marginTop: '0px',
                                                        backgroundColor: "#e9f0fa",
                                                        borderRadius: 1,
                                                        textAlign: "center",
                                                        boxShadow: 2,
                                                        maxHeight: {
                                                            xs: '370px',
                                                            sm: 'calc(70vh - 100px)'
                                                        },
                                                        overflowY: 'auto',
                                                        '@media (max-height: 1000px)': {
                                                            maxHeight: '95%',
                                                            overflowY: 'auto'
                                                        },
                                                        '@media (min-height: 1000px)': {
                                                            maxHeight: '100%'
                                                        }
                                                    }}
                                                    style={{ padding: '25px', }}
                                                >
                                                    <Box
                                                        sx={{
                                                            padding: '4px',
                                                            backgroundColor: "#f0f0f0",
                                                            borderRadius: '2px',
                                                            textAlign: "center",
                                                            borderBottom: '3px dashed #000000c9'

                                                        }}
                                                    >
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "space-between",
                                                                gap: 1,
                                                            }}
                                                        >
                                                            <Box
                                                                sx={{
                                                                    display: "inline-block",
                                                                    padding: "4px 10px !important",
                                                                    backgroundColor: "black",
                                                                    borderRadius: "2px",
                                                                    marginBottom: 0,
                                                                }}
                                                            >
                                                                <Typography variant="subtitle1" sx={{ fontWeight: "bold", color: "white" }}>
                                                                    {currentIndex + 1}
                                                                </Typography>
                                                            </Box>

                                                            <Button
                                                                onClick={() => {
                                                                    if (markedForReview[currentIndex]) {
                                                                        handleBookmarkFalse(currentIndex);
                                                                    } else {
                                                                        handleBookmarkTrue(currentIndex);
                                                                    }
                                                                }}
                                                                className="MarkBtn"
                                                                sx={{
                                                                    minWidth: "auto",
                                                                    color: '#1976d2',
                                                                }}
                                                            >
                                                                {markedForReview[currentIndex] ? (
                                                                    <BookmarkIcon color="#1976d2" />
                                                                ) : (
                                                                    <BookmarkBorderIcon color="#1976d2" />
                                                                )}
                                                                {markedForReview[currentIndex] ? 'Marked for Review' : 'Mark for Review'}
                                                            </Button>
                                                            <Button onClick={() => handleClearResponse()} sx={{ minWidth: "auto", color: '#1976d2', lineHeight: '1.2', }} className="MarkBtn">
                                                                Clear response</Button>
                                                        </Box>
                                                    </Box>
                                                    <Typography className='questionViewer'
                                                        dangerouslySetInnerHTML={{ __html: currentQuestion?.question_text }}
                                                        sx={{
                                                            marginTop: '5px',
                                                            width: "100%",
                                                            textAlign: 'start',
                                                            fontWeight: '400',
                                                            fontSize: { xs: "16px", md: "18px" },
                                                            marginBottom: 1,
                                                            userSelect: 'none'
                                                        }}
                                                        onCopy={(e) => e.preventDefault()}
                                                        onContextMenu={(e) => e.preventDefault()}
                                                    />

                                                    {parsedOptions && parsedOptions?.map((option, index) => (
                                                        <Button id="optionsBtnSAT"
                                                            key={index}
                                                            variant="contained"
                                                            fullWidth
                                                            sx={{
                                                                marginTop: 1,
                                                                backgroundColor: "white",
                                                                color: "black",
                                                                justifyContent: "start",
                                                                border: selectedAnswers[currentIndex] === option ? "3px solid #4caf50" : "1px solid #ccc",
                                                                "&:hover": {
                                                                    backgroundColor: "#f1f1f1",
                                                                },
                                                                fontSize: { xs: "12px", md: "14px" },
                                                            }}
                                                            style={{
                                                                padding: '12px 20px',
                                                                borderRadius: '4px', fontWeight: '400'
                                                            }}
                                                            onClick={() => handleOptionSelect(option, index)}
                                                        >
                                                            <span style={{
                                                                border: '1px solid #aaa',
                                                                borderRadius: '50%',
                                                                padding: '7px',
                                                                height: '30px',
                                                                width: '32px',
                                                                display: 'flex',
                                                                justifyContent: 'center',
                                                                alignItems: 'center',
                                                                marginRight: '12px',
                                                            }}>{String.fromCharCode(97 + index)}</span>
                                                            <span dangerouslySetInnerHTML={{ __html: option }} />
                                                        </Button>
                                                    ))}
                                                </Box>
                                            )}
                                </Grid>


                            }

                            <Popover
                                open={Boolean(questionListAnchorEl)}
                                anchorEl={questionListAnchorEl}
                                onClose={handleCloseQuestionList}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'center',
                                }}
                                transformOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'center',
                                }}
                                PaperProps={{
                                    sx: {
                                        width: '550px',
                                        padding: '32px',
                                        paddingTop: '20px',
                                        overflowY: 'scroll',
                                        overflowX: 'hidden'
                                    }
                                }}
                            >
                                <Box>
                                    <Box sx={{
                                        display: "flex",
                                        flexWrap: 'wrap',
                                        justifyContent: "space-between",
                                        marginBottom: 2,
                                        borderBottom: '2px solid #b1b1b1',
                                        alignItems: 'baseline',
                                        paddingBottom: '12px'
                                    }}>

                                        <Box sx={{ display: "flex", flexBasis: { xs: '50%', sm: '50%', md: 'auto' }, alignItems: "center", marginBottom: "10px" }}>
                                            <Box sx={{ width: 20, height: 20, backgroundColor: "#B3B3B3", borderRadius: "4px", marginRight: 1 }} />
                                            <Typography variant="body2">{"Not Answered"}</Typography>
                                        </Box>
                                        <Box sx={{ display: "flex", flexBasis: { xs: '50%', sm: '50%', md: 'auto' }, alignItems: "center" }}>
                                            <Box sx={{ width: 20, height: 20, backgroundColor: "#4caf50", borderRadius: "4px", marginRight: 1 }} />
                                            <Typography variant="body2">{"Answered"}</Typography>
                                        </Box>
                                        <Box sx={{ display: "flex", flexBasis: { xs: '50%', sm: '50%', md: 'auto' }, alignItems: "center" }}>
                                            <Box sx={{ width: 20, height: 20, backgroundColor: "#2196F3", borderRadius: "4px", marginRight: 1 }} />
                                            <Typography variant="body2">{"Current"}</Typography>
                                        </Box>
                                        <Box sx={{ display: "flex", flexBasis: { xs: '50%', sm: '50%', md: 'auto' }, alignItems: "center" }}>
                                            <Box
                                                sx={{
                                                    backgroundColor: '#f1f1f1',
                                                    width: "20px",
                                                    height: "20px",
                                                    fontWeight: "bold",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    cursor: "pointer",
                                                    borderRadius: '4px',
                                                    color: '#FFFFFF',
                                                    position: "relative",
                                                    marginRight: 1
                                                }}
                                            >
                                                <BookmarkIcon
                                                    sx={{
                                                        position: "absolute",
                                                        top: "0",
                                                        right: "0",
                                                        fontSize: "16px",
                                                        color: "#FE780F",
                                                        transform: "translate(30%, -25%)",
                                                    }}
                                                />
                                            </Box>
                                            <Typography variant="body2">{"Marked for Review"}</Typography>
                                        </Box>
                                    </Box>

                                    <Grid container spacing={2}>
                                        {questions && questions?.length > 0 && questions.map((q, index) => {
                                            const isSelected = currentIndex === index;
                                            const isAnswered = Object.prototype.hasOwnProperty.call(selectedAnswers, index);
                                            const isMarkedForReview = markedForReview[index];

                                            let backgroundColor = "#B3B3B3";
                                            if (isAnswered) backgroundColor = "#4caf50";
                                            if (isSelected) backgroundColor = "#2196F3";

                                            return (
                                                <Grid item xs={2} key={index}>
                                                    <Box
                                                        onClick={() => handleQuestionSelect(index)}
                                                        sx={{
                                                            backgroundColor,
                                                            width: "40px",
                                                            height: "40px",
                                                            fontSize: "14px",
                                                            fontWeight: "bold",
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            cursor: "pointer",
                                                            borderRadius: '4px',
                                                            color: '#FFFFFF',
                                                            boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px',
                                                            position: "relative",
                                                            "&:hover": { backgroundColor: "#1976d2", color: "white" }
                                                        }}
                                                    >
                                                        {isMarkedForReview && (
                                                            <BookmarkIcon
                                                                sx={{
                                                                    position: "absolute",
                                                                    top: "0",
                                                                    right: "0",
                                                                    fontSize: "26px",
                                                                    color: "#FE780F",
                                                                    transform: "translate(30%, -25%)",
                                                                }}
                                                            />
                                                        )}
                                                        {index + 1}
                                                    </Box>
                                                </Grid>
                                            );
                                        })}
                                    </Grid>
                                    <p style={{
                                        height: '5px',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        margin: '0'
                                    }}>
                                        <span className="reviewBtn"
                                            style={{
                                                position: 'relative',

                                            }}><br /></span>
                                    </p>
                                </Box>
                            </Popover>


                            <Box sx={{ backgroundColor: "#e9f0fa", display: "flex", justifyContent: "space-between", height: '60px', padding: '10px 5px !important' }}>
                                <Typography sx={{ display: { xs: 'none', sx: 'none', md: 'block' } }}>{userInfo?.name}</Typography>
                                <Button variant="contained" id="ViewQuestionAll" style={{ backgroundColor: "#434040", borderRadius: '4px', marginLeft: '40px' }} disabled={isPaused} onClick={handleOpenQuestionList}>
                                    {"View all questions"}
                                </Button>
                                <Box sx={{ padding: 1, backgroundColor: "#e9f0fa", display: "flex", justifyContent: "space-between" }}>
                                    <Button
                                        variant="contained"
                                        onClick={handleBack}
                                        disabled={currentIndex === 0 || isPaused}
                                        style={{
                                            marginRight: '10px', background: (currentIndex === 0 || isPaused) ? '#d3d3d3' : '#1976d2',
                                            borderRadius: '4px', color: "#fff"
                                        }} >
                                        {"Back"}
                                    </Button>
                                    {currentIndex === questions?.length - 1 ? (
                                        <Button variant="contained" style={{ background: '#1976d2', borderRadius: '4px', color: "#fff" }} onClick={handleSubmit} disabled={isPaused} >{"Submit"}</Button>
                                    ) : (
                                        <Button variant="contained" style={{ background: '#1976d2', borderRadius: '4px', color: "#fff" }} onClick={() => handleNext()} disabled={isPaused}>{"Next"}</Button>
                                    )}
                                </Box>
                            </Box>
                        </Box>
                    </>
                </Box>


                <Dialog
                    open={openConfirmDialog}
                    onClose={() => setOpenConfirmDialog(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title" style={{ paddingBottom: '0px !important' }} sx={{ pb: 0 }} textAlign={'center'}>
                        {"Do you really want to submit"}
                        <Typography variant="body2" style={{ textAlign: 'center', marginBottom: '10px', fontWeight: '500', fontSize: '17px' }}>

                            {Chapterdetails?.assessment_type === "Maths Chapter Test" ? "Math" : "Reading and Writing"}

                        </Typography>
                    </DialogTitle>
                    <DialogContent style={{ borderTop: '1px solid rgb(163, 163, 163)', borderBottom: '1px solid rgb(163, 163, 163)', overflow: { sx: 'auto', sm: 'auto', md: 'hidden' } }}>

                        <Box id="QuestionModulePop"
                            sx={{
                                margin: 'auto',

                                backgroundColor: 'white',
                                padding: { sx: '0px !important', sm: '10px !important', md: '20px !important' },
                                paddingTop: '15px !important',
                                overflow: 'hidden'

                            }}
                        >

                            {/* <Typography variant="body2" style={{ textAlign: 'center', marginBottom: '5px', fontSize: '16px' }}><b>Module - {submodule}</b></Typography> */}

                            <Box sx={{ display: "flex", flexWrap: 'wrap', justifyContent: "space-between", marginBottom: 2, borderBottom: '2px solid #b1b1b1', alignItems: 'baseline', paddingBottom: '12px !important', }}>
                                <Box sx={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                                    <Box sx={{ width: 20, height: 20, backgroundColor: "#B3B3B3", borderRadius: "4px", marginRight: 1 }} />
                                    <Typography variant="body2">{"Not Answered"}</Typography>
                                </Box>
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                    <Box sx={{ width: 20, height: 20, backgroundColor: "#4caf50", borderRadius: "4px", marginRight: 1 }} />
                                    <Typography variant="body2">{"Answered"}</Typography>
                                </Box>
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                    <Box sx={{ width: 20, height: 20, backgroundColor: "#2196F3", borderRadius: "4px", marginRight: 1 }} />
                                    <Typography variant="body2">{"Current"}</Typography>
                                </Box>
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                    <Box
                                        sx={{
                                            backgroundColor: '#f1f1f1',
                                            width: "20px",
                                            height: "20px",
                                            fontWeight: "bold",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            cursor: "pointer",
                                            borderRadius: '4px',
                                            color: '#FFFFFF',
                                            position: "relative",
                                            marginRight: 1
                                        }}
                                    >
                                        <BookmarkIcon
                                            sx={{
                                                position: "absolute",
                                                top: "0",
                                                right: "0",
                                                fontSize: "16px",
                                                color: "#FE780F",
                                                transform: "translate(30%, -25%)",
                                            }}
                                        />
                                    </Box>
                                    <Typography variant="body2">{"Marked for Review"}</Typography>
                                </Box>
                            </Box>

                            <Grid container spacing={2}>
                                {questions && questions?.length > 0 && questions.map((q, index) => {
                                    const isSelected = currentIndex === index;
                                    const isAnswered = Object.prototype.hasOwnProperty.call(selectedAnswers, index);
                                    const isMarkedForReview = markedForReview[index];

                                    let backgroundColor = "#B3B3B3";
                                    if (isAnswered) backgroundColor = "#4caf50";
                                    if (isSelected) backgroundColor = "#2196F3";

                                    return (
                                        <Grid item xs={2} key={index}>
                                            <Box onClick={() => handleQuestionSelect(index)}

                                                sx={{
                                                    backgroundColor,
                                                    width: "40px",
                                                    height: "40px",
                                                    fontSize: "14px",
                                                    fontWeight: "bold",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    cursor: "pointer",
                                                    borderRadius: '4px',
                                                    color: '#FFFFFF',
                                                    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px',
                                                    position: "relative",
                                                    "&:hover": { backgroundColor: "#1976d2", color: "white" }
                                                }}
                                            >
                                                {isMarkedForReview && (
                                                    <BookmarkIcon
                                                        sx={{
                                                            position: "absolute",
                                                            top: "0",
                                                            right: "0",
                                                            fontSize: "26px",
                                                            color: "#FE780F",
                                                            transform: "translate(30%, -25%)",
                                                        }}
                                                    />
                                                )}
                                                {index + 1}
                                            </Box>
                                        </Grid>
                                    );
                                })}
                            </Grid>
                            <p style={{
                                height: '5px',
                                display: 'flex',
                                justifyContent: 'center',
                                margin: '0'
                            }}>
                                <span className="reviewBtn"
                                    style={{
                                        position: 'relative',

                                    }}><br /></span>
                            </p>
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Box style={{ display: 'flex', justifyContent: 'space-between', flex: 2, padding: '0 20px', marginBottom: '10px' }}>
                            <Button
                                variant="outlined"
                                onClick={() => setOpenConfirmDialog(false)}
                                // color="#1976d2"
                                borderColor="#1976d2"
                                sx={{
                                    border: '1px solid #1976d2',
                                    borderRadius: '4px',
                                    color: '#1976d2',
                                    transition: 'background 0.2s',
                                    '&:hover': {
                                        border: '1px solid #1976d2',
                                        backgroundColor: '#e1f0ff',
                                    },
                                }}
                            >
                                {"Back"}
                            </Button>
                            <Button
                                variant="outlined"
                                onClick={() => handlePostUserResult()}
                                //  color="#1976d2"
                                sx={{
                                    border: '1px solid #1976d2',
                                    borderRadius: '4px',
                                    color: '#1976d2',
                                    transition: 'background 0.2s',
                                    '&:hover': {
                                        border: '1px solid #1976d2',
                                        backgroundColor: '#e1f0ff',
                                    },
                                }}
                            >
                                {"Submit"}
                            </Button>
                        </Box>


                    </DialogActions>
                </Dialog>

                <Dialog

                    open={calculatorOpen}

                    onClose={handleCalculatorClose}

                    PaperComponent={PaperComponent}

                    aria-labelledby="draggable-calculator-dialog"

                    BackdropProps={{ style: { backgroundColor: 'transparent' } }}

                >

                    <DialogTitle

                        className="drag-handle"

                        style={{ cursor: 'move', paddingBottom: '0px' }}

                    >

                        <Box sx={{

                            display: 'flex',

                            justifyContent: 'center',

                            alignItems: 'center'

                        }}>

                            <Typography variant="h4" color="primary" style={{ marginBottom: '8px', color: '#000' }} gutterBottom>

                                Calculator

                            </Typography>

                            <IconButton

                                onClick={handleCalculatorClose}

                                size="small"

                                sx={{ cursor: 'pointer', position: 'absolute', right: '8px', top: '6px' }}

                            >

                                <CloseIcon />

                            </IconButton>

                        </Box>

                    </DialogTitle>

                    <DialogContent sx={{ padding: '8px 2px' }}>

                        <Calculator />

                    </DialogContent>


                </Dialog>


                <Dialog
                    open={showCongratulationsModal}
                    disableEscapeKeyDown
                    slotProps={{
                        backdrop: {
                            style: { backgroundColor: '#fff' }
                        }
                    }}
                    sx={{
                        '& .MuiDialog-paper': {
                            borderRadius: '12px',
                            padding: '20px',
                            textAlign: 'center',
                            minWidth: '400px'
                        }
                    }}
                >
                    <DialogContent sx={{ padding: '20px' }}>
                        <div style={{ marginTop: '0px', paddingBottom: '10px' }}>
                            <div className="flex justify-center mb-4">
                                <div className="relative inline-block">
                                    <img style={{ justifySelf: 'center', width: '60px', marginBottom: '10px' }}
                                        src={TestComplete}
                                        alt="Test Complete Icon"
                                        className="w-16 h-16"
                                    />
                                </div>
                            </div>

                            <h2 className="text-xl font-bold text-blue-600" id="canvas" style={{
                                textAlign: 'center',
                                marginTop: '5px', fontWeight: '700', color: "#6c98fd !important"
                            }}>Congratulations!</h2>
                            <p className="text-gray-600 mt-2" style={{
                                textAlign: 'center', marginTop: '10px'
                            }}>
                                You have successfully completed the Test.
                            </p>

                        </div>

                        <LottieLoading />
                    </DialogContent>
                </Dialog>
            </>
            }
            </>
            )}
        </Box>
    );
}
const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#002b50',
    borderRadius: '4px',
    padding: '2px 10px',
    textAlign: 'center',
    color: "#fff",
    fontSize: '14px'
}));

const useStyles = makeStyles(() => ({
    greetingCard: {
        width: '100%',
        // backgroundColor: '#d2daff',
        borderRadius: '18px',
    }

})); 